// DO NOT EDIT. This file is autogenerated. Run `make generate-foundation-icon-imports` to update.
// Generated at 2026-06-19T07:42:39.727Z

/* eslint-disable -- Autogenerated file */

import type { IconProps } from '@plaid/icons/react/types';
import {
  lazy,
  type ComponentType,
  type LazyExoticComponent,
  type RefAttributes,
} from 'react'; 

type SVGIconProps = IconProps & RefAttributes<SVGSVGElement>;

export const LazyIconModules: Record<
  string,
  LazyExoticComponent<ComponentType<SVGIconProps>>
> = {
  Activity12: lazy(() => {
    return import('@plaid/icons/react/Activity12').then((module) => {
      return { default: module.Activity12 };
    });
  }),
  Activity14: lazy(() => {
    return import('@plaid/icons/react/Activity14').then((module) => {
      return { default: module.Activity14 };
    });
  }),
  Activity16: lazy(() => {
    return import('@plaid/icons/react/Activity16').then((module) => {
      return { default: module.Activity16 };
    });
  }),
  Activity18: lazy(() => {
    return import('@plaid/icons/react/Activity18').then((module) => {
      return { default: module.Activity18 };
    });
  }),
  Activity20: lazy(() => {
    return import('@plaid/icons/react/Activity20').then((module) => {
      return { default: module.Activity20 };
    });
  }),
  Add12: lazy(() => {
    return import('@plaid/icons/react/Add12').then((module) => {
      return { default: module.Add12 };
    });
  }),
  Add14: lazy(() => {
    return import('@plaid/icons/react/Add14').then((module) => {
      return { default: module.Add14 };
    });
  }),
  Add16: lazy(() => {
    return import('@plaid/icons/react/Add16').then((module) => {
      return { default: module.Add16 };
    });
  }),
  Add18: lazy(() => {
    return import('@plaid/icons/react/Add18').then((module) => {
      return { default: module.Add18 };
    });
  }),
  Add20: lazy(() => {
    return import('@plaid/icons/react/Add20').then((module) => {
      return { default: module.Add20 };
    });
  }),
  AddCircle12: lazy(() => {
    return import('@plaid/icons/react/AddCircle12').then((module) => {
      return { default: module.AddCircle12 };
    });
  }),
  AddCircle14: lazy(() => {
    return import('@plaid/icons/react/AddCircle14').then((module) => {
      return { default: module.AddCircle14 };
    });
  }),
  AddCircle16: lazy(() => {
    return import('@plaid/icons/react/AddCircle16').then((module) => {
      return { default: module.AddCircle16 };
    });
  }),
  AddCircle18: lazy(() => {
    return import('@plaid/icons/react/AddCircle18').then((module) => {
      return { default: module.AddCircle18 };
    });
  }),
  AddCircle20: lazy(() => {
    return import('@plaid/icons/react/AddCircle20').then((module) => {
      return { default: module.AddCircle20 };
    });
  }),
  Ai12: lazy(() => {
    return import('@plaid/icons/react/Ai12').then((module) => {
      return { default: module.Ai12 };
    });
  }),
  Ai14: lazy(() => {
    return import('@plaid/icons/react/Ai14').then((module) => {
      return { default: module.Ai14 };
    });
  }),
  Ai16: lazy(() => {
    return import('@plaid/icons/react/Ai16').then((module) => {
      return { default: module.Ai16 };
    });
  }),
  Ai18: lazy(() => {
    return import('@plaid/icons/react/Ai18').then((module) => {
      return { default: module.Ai18 };
    });
  }),
  Ai20: lazy(() => {
    return import('@plaid/icons/react/Ai20').then((module) => {
      return { default: module.Ai20 };
    });
  }),
  AiIndustry12: lazy(() => {
    return import('@plaid/icons/react/AiIndustry12').then((module) => {
      return { default: module.AiIndustry12 };
    });
  }),
  AiIndustry14: lazy(() => {
    return import('@plaid/icons/react/AiIndustry14').then((module) => {
      return { default: module.AiIndustry14 };
    });
  }),
  AiIndustry16: lazy(() => {
    return import('@plaid/icons/react/AiIndustry16').then((module) => {
      return { default: module.AiIndustry16 };
    });
  }),
  AiIndustry18: lazy(() => {
    return import('@plaid/icons/react/AiIndustry18').then((module) => {
      return { default: module.AiIndustry18 };
    });
  }),
  AiIndustry20: lazy(() => {
    return import('@plaid/icons/react/AiIndustry20').then((module) => {
      return { default: module.AiIndustry20 };
    });
  }),
  AlertBell12: lazy(() => {
    return import('@plaid/icons/react/AlertBell12').then((module) => {
      return { default: module.AlertBell12 };
    });
  }),
  AlertBell14: lazy(() => {
    return import('@plaid/icons/react/AlertBell14').then((module) => {
      return { default: module.AlertBell14 };
    });
  }),
  AlertBell16: lazy(() => {
    return import('@plaid/icons/react/AlertBell16').then((module) => {
      return { default: module.AlertBell16 };
    });
  }),
  AlertBell18: lazy(() => {
    return import('@plaid/icons/react/AlertBell18').then((module) => {
      return { default: module.AlertBell18 };
    });
  }),
  AlertBell20: lazy(() => {
    return import('@plaid/icons/react/AlertBell20').then((module) => {
      return { default: module.AlertBell20 };
    });
  }),
  AlertError12: lazy(() => {
    return import('@plaid/icons/react/AlertError12').then((module) => {
      return { default: module.AlertError12 };
    });
  }),
  AlertError14: lazy(() => {
    return import('@plaid/icons/react/AlertError14').then((module) => {
      return { default: module.AlertError14 };
    });
  }),
  AlertError16: lazy(() => {
    return import('@plaid/icons/react/AlertError16').then((module) => {
      return { default: module.AlertError16 };
    });
  }),
  AlertError18: lazy(() => {
    return import('@plaid/icons/react/AlertError18').then((module) => {
      return { default: module.AlertError18 };
    });
  }),
  AlertError20: lazy(() => {
    return import('@plaid/icons/react/AlertError20').then((module) => {
      return { default: module.AlertError20 };
    });
  }),
  AlertWarning12: lazy(() => {
    return import('@plaid/icons/react/AlertWarning12').then((module) => {
      return { default: module.AlertWarning12 };
    });
  }),
  AlertWarning14: lazy(() => {
    return import('@plaid/icons/react/AlertWarning14').then((module) => {
      return { default: module.AlertWarning14 };
    });
  }),
  AlertWarning16: lazy(() => {
    return import('@plaid/icons/react/AlertWarning16').then((module) => {
      return { default: module.AlertWarning16 };
    });
  }),
  AlertWarning18: lazy(() => {
    return import('@plaid/icons/react/AlertWarning18').then((module) => {
      return { default: module.AlertWarning18 };
    });
  }),
  AlertWarning20: lazy(() => {
    return import('@plaid/icons/react/AlertWarning20').then((module) => {
      return { default: module.AlertWarning20 };
    });
  }),
  AppearanceHide12: lazy(() => {
    return import('@plaid/icons/react/AppearanceHide12').then((module) => {
      return { default: module.AppearanceHide12 };
    });
  }),
  AppearanceHide14: lazy(() => {
    return import('@plaid/icons/react/AppearanceHide14').then((module) => {
      return { default: module.AppearanceHide14 };
    });
  }),
  AppearanceHide16: lazy(() => {
    return import('@plaid/icons/react/AppearanceHide16').then((module) => {
      return { default: module.AppearanceHide16 };
    });
  }),
  AppearanceHide18: lazy(() => {
    return import('@plaid/icons/react/AppearanceHide18').then((module) => {
      return { default: module.AppearanceHide18 };
    });
  }),
  AppearanceHide20: lazy(() => {
    return import('@plaid/icons/react/AppearanceHide20').then((module) => {
      return { default: module.AppearanceHide20 };
    });
  }),
  AppearanceShow12: lazy(() => {
    return import('@plaid/icons/react/AppearanceShow12').then((module) => {
      return { default: module.AppearanceShow12 };
    });
  }),
  AppearanceShow14: lazy(() => {
    return import('@plaid/icons/react/AppearanceShow14').then((module) => {
      return { default: module.AppearanceShow14 };
    });
  }),
  AppearanceShow16: lazy(() => {
    return import('@plaid/icons/react/AppearanceShow16').then((module) => {
      return { default: module.AppearanceShow16 };
    });
  }),
  AppearanceShow18: lazy(() => {
    return import('@plaid/icons/react/AppearanceShow18').then((module) => {
      return { default: module.AppearanceShow18 };
    });
  }),
  AppearanceShow20: lazy(() => {
    return import('@plaid/icons/react/AppearanceShow20').then((module) => {
      return { default: module.AppearanceShow20 };
    });
  }),
  ArrowDown12: lazy(() => {
    return import('@plaid/icons/react/ArrowDown12').then((module) => {
      return { default: module.ArrowDown12 };
    });
  }),
  ArrowDown14: lazy(() => {
    return import('@plaid/icons/react/ArrowDown14').then((module) => {
      return { default: module.ArrowDown14 };
    });
  }),
  ArrowDown16: lazy(() => {
    return import('@plaid/icons/react/ArrowDown16').then((module) => {
      return { default: module.ArrowDown16 };
    });
  }),
  ArrowDown18: lazy(() => {
    return import('@plaid/icons/react/ArrowDown18').then((module) => {
      return { default: module.ArrowDown18 };
    });
  }),
  ArrowDown20: lazy(() => {
    return import('@plaid/icons/react/ArrowDown20').then((module) => {
      return { default: module.ArrowDown20 };
    });
  }),
  ArrowLeft12: lazy(() => {
    return import('@plaid/icons/react/ArrowLeft12').then((module) => {
      return { default: module.ArrowLeft12 };
    });
  }),
  ArrowLeft14: lazy(() => {
    return import('@plaid/icons/react/ArrowLeft14').then((module) => {
      return { default: module.ArrowLeft14 };
    });
  }),
  ArrowLeft16: lazy(() => {
    return import('@plaid/icons/react/ArrowLeft16').then((module) => {
      return { default: module.ArrowLeft16 };
    });
  }),
  ArrowLeft18: lazy(() => {
    return import('@plaid/icons/react/ArrowLeft18').then((module) => {
      return { default: module.ArrowLeft18 };
    });
  }),
  ArrowLeft20: lazy(() => {
    return import('@plaid/icons/react/ArrowLeft20').then((module) => {
      return { default: module.ArrowLeft20 };
    });
  }),
  ArrowRight12: lazy(() => {
    return import('@plaid/icons/react/ArrowRight12').then((module) => {
      return { default: module.ArrowRight12 };
    });
  }),
  ArrowRight14: lazy(() => {
    return import('@plaid/icons/react/ArrowRight14').then((module) => {
      return { default: module.ArrowRight14 };
    });
  }),
  ArrowRight16: lazy(() => {
    return import('@plaid/icons/react/ArrowRight16').then((module) => {
      return { default: module.ArrowRight16 };
    });
  }),
  ArrowRight18: lazy(() => {
    return import('@plaid/icons/react/ArrowRight18').then((module) => {
      return { default: module.ArrowRight18 };
    });
  }),
  ArrowRight20: lazy(() => {
    return import('@plaid/icons/react/ArrowRight20').then((module) => {
      return { default: module.ArrowRight20 };
    });
  }),
  ArrowRightDown12: lazy(() => {
    return import('@plaid/icons/react/ArrowRightDown12').then((module) => {
      return { default: module.ArrowRightDown12 };
    });
  }),
  ArrowRightDown14: lazy(() => {
    return import('@plaid/icons/react/ArrowRightDown14').then((module) => {
      return { default: module.ArrowRightDown14 };
    });
  }),
  ArrowRightDown16: lazy(() => {
    return import('@plaid/icons/react/ArrowRightDown16').then((module) => {
      return { default: module.ArrowRightDown16 };
    });
  }),
  ArrowRightDown18: lazy(() => {
    return import('@plaid/icons/react/ArrowRightDown18').then((module) => {
      return { default: module.ArrowRightDown18 };
    });
  }),
  ArrowRightDown20: lazy(() => {
    return import('@plaid/icons/react/ArrowRightDown20').then((module) => {
      return { default: module.ArrowRightDown20 };
    });
  }),
  ArrowUp12: lazy(() => {
    return import('@plaid/icons/react/ArrowUp12').then((module) => {
      return { default: module.ArrowUp12 };
    });
  }),
  ArrowUp14: lazy(() => {
    return import('@plaid/icons/react/ArrowUp14').then((module) => {
      return { default: module.ArrowUp14 };
    });
  }),
  ArrowUp16: lazy(() => {
    return import('@plaid/icons/react/ArrowUp16').then((module) => {
      return { default: module.ArrowUp16 };
    });
  }),
  ArrowUp18: lazy(() => {
    return import('@plaid/icons/react/ArrowUp18').then((module) => {
      return { default: module.ArrowUp18 };
    });
  }),
  ArrowUp20: lazy(() => {
    return import('@plaid/icons/react/ArrowUp20').then((module) => {
      return { default: module.ArrowUp20 };
    });
  }),
  Attachment12: lazy(() => {
    return import('@plaid/icons/react/Attachment12').then((module) => {
      return { default: module.Attachment12 };
    });
  }),
  Attachment14: lazy(() => {
    return import('@plaid/icons/react/Attachment14').then((module) => {
      return { default: module.Attachment14 };
    });
  }),
  Attachment16: lazy(() => {
    return import('@plaid/icons/react/Attachment16').then((module) => {
      return { default: module.Attachment16 };
    });
  }),
  Attachment18: lazy(() => {
    return import('@plaid/icons/react/Attachment18').then((module) => {
      return { default: module.Attachment18 };
    });
  }),
  Attachment20: lazy(() => {
    return import('@plaid/icons/react/Attachment20').then((module) => {
      return { default: module.Attachment20 };
    });
  }),
  BankIntelligence12: lazy(() => {
    return import('@plaid/icons/react/BankIntelligence12').then((module) => {
      return { default: module.BankIntelligence12 };
    });
  }),
  BankIntelligence14: lazy(() => {
    return import('@plaid/icons/react/BankIntelligence14').then((module) => {
      return { default: module.BankIntelligence14 };
    });
  }),
  BankIntelligence16: lazy(() => {
    return import('@plaid/icons/react/BankIntelligence16').then((module) => {
      return { default: module.BankIntelligence16 };
    });
  }),
  BankIntelligence18: lazy(() => {
    return import('@plaid/icons/react/BankIntelligence18').then((module) => {
      return { default: module.BankIntelligence18 };
    });
  }),
  BankIntelligence20: lazy(() => {
    return import('@plaid/icons/react/BankIntelligence20').then((module) => {
      return { default: module.BankIntelligence20 };
    });
  }),
  BarGraph12: lazy(() => {
    return import('@plaid/icons/react/BarGraph12').then((module) => {
      return { default: module.BarGraph12 };
    });
  }),
  BarGraph14: lazy(() => {
    return import('@plaid/icons/react/BarGraph14').then((module) => {
      return { default: module.BarGraph14 };
    });
  }),
  BarGraph16: lazy(() => {
    return import('@plaid/icons/react/BarGraph16').then((module) => {
      return { default: module.BarGraph16 };
    });
  }),
  BarGraph18: lazy(() => {
    return import('@plaid/icons/react/BarGraph18').then((module) => {
      return { default: module.BarGraph18 };
    });
  }),
  BarGraph20: lazy(() => {
    return import('@plaid/icons/react/BarGraph20').then((module) => {
      return { default: module.BarGraph20 };
    });
  }),
  Behavior12: lazy(() => {
    return import('@plaid/icons/react/Behavior12').then((module) => {
      return { default: module.Behavior12 };
    });
  }),
  Behavior14: lazy(() => {
    return import('@plaid/icons/react/Behavior14').then((module) => {
      return { default: module.Behavior14 };
    });
  }),
  Behavior16: lazy(() => {
    return import('@plaid/icons/react/Behavior16').then((module) => {
      return { default: module.Behavior16 };
    });
  }),
  Behavior18: lazy(() => {
    return import('@plaid/icons/react/Behavior18').then((module) => {
      return { default: module.Behavior18 };
    });
  }),
  Behavior20: lazy(() => {
    return import('@plaid/icons/react/Behavior20').then((module) => {
      return { default: module.Behavior20 };
    });
  }),
  Book12: lazy(() => {
    return import('@plaid/icons/react/Book12').then((module) => {
      return { default: module.Book12 };
    });
  }),
  Book14: lazy(() => {
    return import('@plaid/icons/react/Book14').then((module) => {
      return { default: module.Book14 };
    });
  }),
  Book16: lazy(() => {
    return import('@plaid/icons/react/Book16').then((module) => {
      return { default: module.Book16 };
    });
  }),
  Book18: lazy(() => {
    return import('@plaid/icons/react/Book18').then((module) => {
      return { default: module.Book18 };
    });
  }),
  Book20: lazy(() => {
    return import('@plaid/icons/react/Book20').then((module) => {
      return { default: module.Book20 };
    });
  }),
  Bookmark12: lazy(() => {
    return import('@plaid/icons/react/Bookmark12').then((module) => {
      return { default: module.Bookmark12 };
    });
  }),
  Bookmark14: lazy(() => {
    return import('@plaid/icons/react/Bookmark14').then((module) => {
      return { default: module.Bookmark14 };
    });
  }),
  Bookmark16: lazy(() => {
    return import('@plaid/icons/react/Bookmark16').then((module) => {
      return { default: module.Bookmark16 };
    });
  }),
  Bookmark18: lazy(() => {
    return import('@plaid/icons/react/Bookmark18').then((module) => {
      return { default: module.Bookmark18 };
    });
  }),
  Bookmark20: lazy(() => {
    return import('@plaid/icons/react/Bookmark20').then((module) => {
      return { default: module.Bookmark20 };
    });
  }),
  BookOpen12: lazy(() => {
    return import('@plaid/icons/react/BookOpen12').then((module) => {
      return { default: module.BookOpen12 };
    });
  }),
  BookOpen14: lazy(() => {
    return import('@plaid/icons/react/BookOpen14').then((module) => {
      return { default: module.BookOpen14 };
    });
  }),
  BookOpen16: lazy(() => {
    return import('@plaid/icons/react/BookOpen16').then((module) => {
      return { default: module.BookOpen16 };
    });
  }),
  BookOpen18: lazy(() => {
    return import('@plaid/icons/react/BookOpen18').then((module) => {
      return { default: module.BookOpen18 };
    });
  }),
  BookOpen20: lazy(() => {
    return import('@plaid/icons/react/BookOpen20').then((module) => {
      return { default: module.BookOpen20 };
    });
  }),
  Bot12: lazy(() => {
    return import('@plaid/icons/react/Bot12').then((module) => {
      return { default: module.Bot12 };
    });
  }),
  Bot14: lazy(() => {
    return import('@plaid/icons/react/Bot14').then((module) => {
      return { default: module.Bot14 };
    });
  }),
  Bot16: lazy(() => {
    return import('@plaid/icons/react/Bot16').then((module) => {
      return { default: module.Bot16 };
    });
  }),
  Bot18: lazy(() => {
    return import('@plaid/icons/react/Bot18').then((module) => {
      return { default: module.Bot18 };
    });
  }),
  Bot20: lazy(() => {
    return import('@plaid/icons/react/Bot20').then((module) => {
      return { default: module.Bot20 };
    });
  }),
  Briefcase12: lazy(() => {
    return import('@plaid/icons/react/Briefcase12').then((module) => {
      return { default: module.Briefcase12 };
    });
  }),
  Briefcase14: lazy(() => {
    return import('@plaid/icons/react/Briefcase14').then((module) => {
      return { default: module.Briefcase14 };
    });
  }),
  Briefcase16: lazy(() => {
    return import('@plaid/icons/react/Briefcase16').then((module) => {
      return { default: module.Briefcase16 };
    });
  }),
  Briefcase18: lazy(() => {
    return import('@plaid/icons/react/Briefcase18').then((module) => {
      return { default: module.Briefcase18 };
    });
  }),
  Briefcase20: lazy(() => {
    return import('@plaid/icons/react/Briefcase20').then((module) => {
      return { default: module.Briefcase20 };
    });
  }),
  Build12: lazy(() => {
    return import('@plaid/icons/react/Build12').then((module) => {
      return { default: module.Build12 };
    });
  }),
  Build14: lazy(() => {
    return import('@plaid/icons/react/Build14').then((module) => {
      return { default: module.Build14 };
    });
  }),
  Build16: lazy(() => {
    return import('@plaid/icons/react/Build16').then((module) => {
      return { default: module.Build16 };
    });
  }),
  Build18: lazy(() => {
    return import('@plaid/icons/react/Build18').then((module) => {
      return { default: module.Build18 };
    });
  }),
  Build20: lazy(() => {
    return import('@plaid/icons/react/Build20').then((module) => {
      return { default: module.Build20 };
    });
  }),
  Buildings12: lazy(() => {
    return import('@plaid/icons/react/Buildings12').then((module) => {
      return { default: module.Buildings12 };
    });
  }),
  Buildings14: lazy(() => {
    return import('@plaid/icons/react/Buildings14').then((module) => {
      return { default: module.Buildings14 };
    });
  }),
  Buildings16: lazy(() => {
    return import('@plaid/icons/react/Buildings16').then((module) => {
      return { default: module.Buildings16 };
    });
  }),
  Buildings18: lazy(() => {
    return import('@plaid/icons/react/Buildings18').then((module) => {
      return { default: module.Buildings18 };
    });
  }),
  Buildings20: lazy(() => {
    return import('@plaid/icons/react/Buildings20').then((module) => {
      return { default: module.Buildings20 };
    });
  }),
  Bullet12: lazy(() => {
    return import('@plaid/icons/react/Bullet12').then((module) => {
      return { default: module.Bullet12 };
    });
  }),
  Bullet14: lazy(() => {
    return import('@plaid/icons/react/Bullet14').then((module) => {
      return { default: module.Bullet14 };
    });
  }),
  Bullet16: lazy(() => {
    return import('@plaid/icons/react/Bullet16').then((module) => {
      return { default: module.Bullet16 };
    });
  }),
  Bullet18: lazy(() => {
    return import('@plaid/icons/react/Bullet18').then((module) => {
      return { default: module.Bullet18 };
    });
  }),
  Bullet20: lazy(() => {
    return import('@plaid/icons/react/Bullet20').then((module) => {
      return { default: module.Bullet20 };
    });
  }),
  Calendar12: lazy(() => {
    return import('@plaid/icons/react/Calendar12').then((module) => {
      return { default: module.Calendar12 };
    });
  }),
  Calendar14: lazy(() => {
    return import('@plaid/icons/react/Calendar14').then((module) => {
      return { default: module.Calendar14 };
    });
  }),
  Calendar16: lazy(() => {
    return import('@plaid/icons/react/Calendar16').then((module) => {
      return { default: module.Calendar16 };
    });
  }),
  Calendar18: lazy(() => {
    return import('@plaid/icons/react/Calendar18').then((module) => {
      return { default: module.Calendar18 };
    });
  }),
  Calendar20: lazy(() => {
    return import('@plaid/icons/react/Calendar20').then((module) => {
      return { default: module.Calendar20 };
    });
  }),
  Cancel12: lazy(() => {
    return import('@plaid/icons/react/Cancel12').then((module) => {
      return { default: module.Cancel12 };
    });
  }),
  Cancel14: lazy(() => {
    return import('@plaid/icons/react/Cancel14').then((module) => {
      return { default: module.Cancel14 };
    });
  }),
  Cancel16: lazy(() => {
    return import('@plaid/icons/react/Cancel16').then((module) => {
      return { default: module.Cancel16 };
    });
  }),
  Cancel18: lazy(() => {
    return import('@plaid/icons/react/Cancel18').then((module) => {
      return { default: module.Cancel18 };
    });
  }),
  Cancel20: lazy(() => {
    return import('@plaid/icons/react/Cancel20').then((module) => {
      return { default: module.Cancel20 };
    });
  }),
  Car12: lazy(() => {
    return import('@plaid/icons/react/Car12').then((module) => {
      return { default: module.Car12 };
    });
  }),
  Car14: lazy(() => {
    return import('@plaid/icons/react/Car14').then((module) => {
      return { default: module.Car14 };
    });
  }),
  Car16: lazy(() => {
    return import('@plaid/icons/react/Car16').then((module) => {
      return { default: module.Car16 };
    });
  }),
  Car18: lazy(() => {
    return import('@plaid/icons/react/Car18').then((module) => {
      return { default: module.Car18 };
    });
  }),
  Car20: lazy(() => {
    return import('@plaid/icons/react/Car20').then((module) => {
      return { default: module.Car20 };
    });
  }),
  Cart12: lazy(() => {
    return import('@plaid/icons/react/Cart12').then((module) => {
      return { default: module.Cart12 };
    });
  }),
  Cart14: lazy(() => {
    return import('@plaid/icons/react/Cart14').then((module) => {
      return { default: module.Cart14 };
    });
  }),
  Cart16: lazy(() => {
    return import('@plaid/icons/react/Cart16').then((module) => {
      return { default: module.Cart16 };
    });
  }),
  Cart18: lazy(() => {
    return import('@plaid/icons/react/Cart18').then((module) => {
      return { default: module.Cart18 };
    });
  }),
  Cart20: lazy(() => {
    return import('@plaid/icons/react/Cart20').then((module) => {
      return { default: module.Cart20 };
    });
  }),
  Categories12: lazy(() => {
    return import('@plaid/icons/react/Categories12').then((module) => {
      return { default: module.Categories12 };
    });
  }),
  Categories14: lazy(() => {
    return import('@plaid/icons/react/Categories14').then((module) => {
      return { default: module.Categories14 };
    });
  }),
  Categories16: lazy(() => {
    return import('@plaid/icons/react/Categories16').then((module) => {
      return { default: module.Categories16 };
    });
  }),
  Categories18: lazy(() => {
    return import('@plaid/icons/react/Categories18').then((module) => {
      return { default: module.Categories18 };
    });
  }),
  Categories20: lazy(() => {
    return import('@plaid/icons/react/Categories20').then((module) => {
      return { default: module.Categories20 };
    });
  }),
  Changelog12: lazy(() => {
    return import('@plaid/icons/react/Changelog12').then((module) => {
      return { default: module.Changelog12 };
    });
  }),
  Changelog14: lazy(() => {
    return import('@plaid/icons/react/Changelog14').then((module) => {
      return { default: module.Changelog14 };
    });
  }),
  Changelog16: lazy(() => {
    return import('@plaid/icons/react/Changelog16').then((module) => {
      return { default: module.Changelog16 };
    });
  }),
  Changelog18: lazy(() => {
    return import('@plaid/icons/react/Changelog18').then((module) => {
      return { default: module.Changelog18 };
    });
  }),
  Changelog20: lazy(() => {
    return import('@plaid/icons/react/Changelog20').then((module) => {
      return { default: module.Changelog20 };
    });
  }),
  Check12: lazy(() => {
    return import('@plaid/icons/react/Check12').then((module) => {
      return { default: module.Check12 };
    });
  }),
  Check14: lazy(() => {
    return import('@plaid/icons/react/Check14').then((module) => {
      return { default: module.Check14 };
    });
  }),
  Check16: lazy(() => {
    return import('@plaid/icons/react/Check16').then((module) => {
      return { default: module.Check16 };
    });
  }),
  Check18: lazy(() => {
    return import('@plaid/icons/react/Check18').then((module) => {
      return { default: module.Check18 };
    });
  }),
  Check20: lazy(() => {
    return import('@plaid/icons/react/Check20').then((module) => {
      return { default: module.Check20 };
    });
  }),
  Checkmark12: lazy(() => {
    return import('@plaid/icons/react/Checkmark12').then((module) => {
      return { default: module.Checkmark12 };
    });
  }),
  Checkmark14: lazy(() => {
    return import('@plaid/icons/react/Checkmark14').then((module) => {
      return { default: module.Checkmark14 };
    });
  }),
  Checkmark16: lazy(() => {
    return import('@plaid/icons/react/Checkmark16').then((module) => {
      return { default: module.Checkmark16 };
    });
  }),
  Checkmark18: lazy(() => {
    return import('@plaid/icons/react/Checkmark18').then((module) => {
      return { default: module.Checkmark18 };
    });
  }),
  Checkmark20: lazy(() => {
    return import('@plaid/icons/react/Checkmark20').then((module) => {
      return { default: module.Checkmark20 };
    });
  }),
  ChevronDoubleLeft12: lazy(() => {
    return import('@plaid/icons/react/ChevronDoubleLeft12').then((module) => {
      return { default: module.ChevronDoubleLeft12 };
    });
  }),
  ChevronDoubleLeft14: lazy(() => {
    return import('@plaid/icons/react/ChevronDoubleLeft14').then((module) => {
      return { default: module.ChevronDoubleLeft14 };
    });
  }),
  ChevronDoubleLeft16: lazy(() => {
    return import('@plaid/icons/react/ChevronDoubleLeft16').then((module) => {
      return { default: module.ChevronDoubleLeft16 };
    });
  }),
  ChevronDoubleLeft18: lazy(() => {
    return import('@plaid/icons/react/ChevronDoubleLeft18').then((module) => {
      return { default: module.ChevronDoubleLeft18 };
    });
  }),
  ChevronDoubleLeft20: lazy(() => {
    return import('@plaid/icons/react/ChevronDoubleLeft20').then((module) => {
      return { default: module.ChevronDoubleLeft20 };
    });
  }),
  ChevronDown12: lazy(() => {
    return import('@plaid/icons/react/ChevronDown12').then((module) => {
      return { default: module.ChevronDown12 };
    });
  }),
  ChevronDown14: lazy(() => {
    return import('@plaid/icons/react/ChevronDown14').then((module) => {
      return { default: module.ChevronDown14 };
    });
  }),
  ChevronDown16: lazy(() => {
    return import('@plaid/icons/react/ChevronDown16').then((module) => {
      return { default: module.ChevronDown16 };
    });
  }),
  ChevronDown18: lazy(() => {
    return import('@plaid/icons/react/ChevronDown18').then((module) => {
      return { default: module.ChevronDown18 };
    });
  }),
  ChevronDown20: lazy(() => {
    return import('@plaid/icons/react/ChevronDown20').then((module) => {
      return { default: module.ChevronDown20 };
    });
  }),
  ChevronLeft12: lazy(() => {
    return import('@plaid/icons/react/ChevronLeft12').then((module) => {
      return { default: module.ChevronLeft12 };
    });
  }),
  ChevronLeft14: lazy(() => {
    return import('@plaid/icons/react/ChevronLeft14').then((module) => {
      return { default: module.ChevronLeft14 };
    });
  }),
  ChevronLeft16: lazy(() => {
    return import('@plaid/icons/react/ChevronLeft16').then((module) => {
      return { default: module.ChevronLeft16 };
    });
  }),
  ChevronLeft18: lazy(() => {
    return import('@plaid/icons/react/ChevronLeft18').then((module) => {
      return { default: module.ChevronLeft18 };
    });
  }),
  ChevronLeft20: lazy(() => {
    return import('@plaid/icons/react/ChevronLeft20').then((module) => {
      return { default: module.ChevronLeft20 };
    });
  }),
  ChevronRight12: lazy(() => {
    return import('@plaid/icons/react/ChevronRight12').then((module) => {
      return { default: module.ChevronRight12 };
    });
  }),
  ChevronRight14: lazy(() => {
    return import('@plaid/icons/react/ChevronRight14').then((module) => {
      return { default: module.ChevronRight14 };
    });
  }),
  ChevronRight16: lazy(() => {
    return import('@plaid/icons/react/ChevronRight16').then((module) => {
      return { default: module.ChevronRight16 };
    });
  }),
  ChevronRight18: lazy(() => {
    return import('@plaid/icons/react/ChevronRight18').then((module) => {
      return { default: module.ChevronRight18 };
    });
  }),
  ChevronRight20: lazy(() => {
    return import('@plaid/icons/react/ChevronRight20').then((module) => {
      return { default: module.ChevronRight20 };
    });
  }),
  ChevronRightDouble12: lazy(() => {
    return import('@plaid/icons/react/ChevronRightDouble12').then((module) => {
      return { default: module.ChevronRightDouble12 };
    });
  }),
  ChevronRightDouble14: lazy(() => {
    return import('@plaid/icons/react/ChevronRightDouble14').then((module) => {
      return { default: module.ChevronRightDouble14 };
    });
  }),
  ChevronRightDouble16: lazy(() => {
    return import('@plaid/icons/react/ChevronRightDouble16').then((module) => {
      return { default: module.ChevronRightDouble16 };
    });
  }),
  ChevronRightDouble18: lazy(() => {
    return import('@plaid/icons/react/ChevronRightDouble18').then((module) => {
      return { default: module.ChevronRightDouble18 };
    });
  }),
  ChevronRightDouble20: lazy(() => {
    return import('@plaid/icons/react/ChevronRightDouble20').then((module) => {
      return { default: module.ChevronRightDouble20 };
    });
  }),
  ChevronUp12: lazy(() => {
    return import('@plaid/icons/react/ChevronUp12').then((module) => {
      return { default: module.ChevronUp12 };
    });
  }),
  ChevronUp14: lazy(() => {
    return import('@plaid/icons/react/ChevronUp14').then((module) => {
      return { default: module.ChevronUp14 };
    });
  }),
  ChevronUp16: lazy(() => {
    return import('@plaid/icons/react/ChevronUp16').then((module) => {
      return { default: module.ChevronUp16 };
    });
  }),
  ChevronUp18: lazy(() => {
    return import('@plaid/icons/react/ChevronUp18').then((module) => {
      return { default: module.ChevronUp18 };
    });
  }),
  ChevronUp20: lazy(() => {
    return import('@plaid/icons/react/ChevronUp20').then((module) => {
      return { default: module.ChevronUp20 };
    });
  }),
  ClearedRec12: lazy(() => {
    return import('@plaid/icons/react/ClearedRec12').then((module) => {
      return { default: module.ClearedRec12 };
    });
  }),
  ClearedRec14: lazy(() => {
    return import('@plaid/icons/react/ClearedRec14').then((module) => {
      return { default: module.ClearedRec14 };
    });
  }),
  ClearedRec16: lazy(() => {
    return import('@plaid/icons/react/ClearedRec16').then((module) => {
      return { default: module.ClearedRec16 };
    });
  }),
  ClearedRec18: lazy(() => {
    return import('@plaid/icons/react/ClearedRec18').then((module) => {
      return { default: module.ClearedRec18 };
    });
  }),
  ClearedRec20: lazy(() => {
    return import('@plaid/icons/react/ClearedRec20').then((module) => {
      return { default: module.ClearedRec20 };
    });
  }),
  Clipboard12: lazy(() => {
    return import('@plaid/icons/react/Clipboard12').then((module) => {
      return { default: module.Clipboard12 };
    });
  }),
  Clipboard14: lazy(() => {
    return import('@plaid/icons/react/Clipboard14').then((module) => {
      return { default: module.Clipboard14 };
    });
  }),
  Clipboard16: lazy(() => {
    return import('@plaid/icons/react/Clipboard16').then((module) => {
      return { default: module.Clipboard16 };
    });
  }),
  Clipboard18: lazy(() => {
    return import('@plaid/icons/react/Clipboard18').then((module) => {
      return { default: module.Clipboard18 };
    });
  }),
  Clipboard20: lazy(() => {
    return import('@plaid/icons/react/Clipboard20').then((module) => {
      return { default: module.Clipboard20 };
    });
  }),
  Clock12: lazy(() => {
    return import('@plaid/icons/react/Clock12').then((module) => {
      return { default: module.Clock12 };
    });
  }),
  Clock14: lazy(() => {
    return import('@plaid/icons/react/Clock14').then((module) => {
      return { default: module.Clock14 };
    });
  }),
  Clock16: lazy(() => {
    return import('@plaid/icons/react/Clock16').then((module) => {
      return { default: module.Clock16 };
    });
  }),
  Clock18: lazy(() => {
    return import('@plaid/icons/react/Clock18').then((module) => {
      return { default: module.Clock18 };
    });
  }),
  Clock20: lazy(() => {
    return import('@plaid/icons/react/Clock20').then((module) => {
      return { default: module.Clock20 };
    });
  }),
  Close12: lazy(() => {
    return import('@plaid/icons/react/Close12').then((module) => {
      return { default: module.Close12 };
    });
  }),
  Close14: lazy(() => {
    return import('@plaid/icons/react/Close14').then((module) => {
      return { default: module.Close14 };
    });
  }),
  Close16: lazy(() => {
    return import('@plaid/icons/react/Close16').then((module) => {
      return { default: module.Close16 };
    });
  }),
  Close18: lazy(() => {
    return import('@plaid/icons/react/Close18').then((module) => {
      return { default: module.Close18 };
    });
  }),
  Close20: lazy(() => {
    return import('@plaid/icons/react/Close20').then((module) => {
      return { default: module.Close20 };
    });
  }),
  Comment12: lazy(() => {
    return import('@plaid/icons/react/Comment12').then((module) => {
      return { default: module.Comment12 };
    });
  }),
  Comment14: lazy(() => {
    return import('@plaid/icons/react/Comment14').then((module) => {
      return { default: module.Comment14 };
    });
  }),
  Comment16: lazy(() => {
    return import('@plaid/icons/react/Comment16').then((module) => {
      return { default: module.Comment16 };
    });
  }),
  Comment18: lazy(() => {
    return import('@plaid/icons/react/Comment18').then((module) => {
      return { default: module.Comment18 };
    });
  }),
  Comment20: lazy(() => {
    return import('@plaid/icons/react/Comment20').then((module) => {
      return { default: module.Comment20 };
    });
  }),
  Configure12: lazy(() => {
    return import('@plaid/icons/react/Configure12').then((module) => {
      return { default: module.Configure12 };
    });
  }),
  Configure14: lazy(() => {
    return import('@plaid/icons/react/Configure14').then((module) => {
      return { default: module.Configure14 };
    });
  }),
  Configure16: lazy(() => {
    return import('@plaid/icons/react/Configure16').then((module) => {
      return { default: module.Configure16 };
    });
  }),
  Configure18: lazy(() => {
    return import('@plaid/icons/react/Configure18').then((module) => {
      return { default: module.Configure18 };
    });
  }),
  Configure20: lazy(() => {
    return import('@plaid/icons/react/Configure20').then((module) => {
      return { default: module.Configure20 };
    });
  }),
  Copy12: lazy(() => {
    return import('@plaid/icons/react/Copy12').then((module) => {
      return { default: module.Copy12 };
    });
  }),
  Copy14: lazy(() => {
    return import('@plaid/icons/react/Copy14').then((module) => {
      return { default: module.Copy14 };
    });
  }),
  Copy16: lazy(() => {
    return import('@plaid/icons/react/Copy16').then((module) => {
      return { default: module.Copy16 };
    });
  }),
  Copy18: lazy(() => {
    return import('@plaid/icons/react/Copy18').then((module) => {
      return { default: module.Copy18 };
    });
  }),
  Copy20: lazy(() => {
    return import('@plaid/icons/react/Copy20').then((module) => {
      return { default: module.Copy20 };
    });
  }),
  CreditCard12: lazy(() => {
    return import('@plaid/icons/react/CreditCard12').then((module) => {
      return { default: module.CreditCard12 };
    });
  }),
  CreditCard14: lazy(() => {
    return import('@plaid/icons/react/CreditCard14').then((module) => {
      return { default: module.CreditCard14 };
    });
  }),
  CreditCard16: lazy(() => {
    return import('@plaid/icons/react/CreditCard16').then((module) => {
      return { default: module.CreditCard16 };
    });
  }),
  CreditCard18: lazy(() => {
    return import('@plaid/icons/react/CreditCard18').then((module) => {
      return { default: module.CreditCard18 };
    });
  }),
  CreditCard20: lazy(() => {
    return import('@plaid/icons/react/CreditCard20').then((module) => {
      return { default: module.CreditCard20 };
    });
  }),
  Database12: lazy(() => {
    return import('@plaid/icons/react/Database12').then((module) => {
      return { default: module.Database12 };
    });
  }),
  Database14: lazy(() => {
    return import('@plaid/icons/react/Database14').then((module) => {
      return { default: module.Database14 };
    });
  }),
  Database16: lazy(() => {
    return import('@plaid/icons/react/Database16').then((module) => {
      return { default: module.Database16 };
    });
  }),
  Database18: lazy(() => {
    return import('@plaid/icons/react/Database18').then((module) => {
      return { default: module.Database18 };
    });
  }),
  Database20: lazy(() => {
    return import('@plaid/icons/react/Database20').then((module) => {
      return { default: module.Database20 };
    });
  }),
  Demo12: lazy(() => {
    return import('@plaid/icons/react/Demo12').then((module) => {
      return { default: module.Demo12 };
    });
  }),
  Demo14: lazy(() => {
    return import('@plaid/icons/react/Demo14').then((module) => {
      return { default: module.Demo14 };
    });
  }),
  Demo16: lazy(() => {
    return import('@plaid/icons/react/Demo16').then((module) => {
      return { default: module.Demo16 };
    });
  }),
  Demo18: lazy(() => {
    return import('@plaid/icons/react/Demo18').then((module) => {
      return { default: module.Demo18 };
    });
  }),
  Demo20: lazy(() => {
    return import('@plaid/icons/react/Demo20').then((module) => {
      return { default: module.Demo20 };
    });
  }),
  Dice12: lazy(() => {
    return import('@plaid/icons/react/Dice12').then((module) => {
      return { default: module.Dice12 };
    });
  }),
  Dice14: lazy(() => {
    return import('@plaid/icons/react/Dice14').then((module) => {
      return { default: module.Dice14 };
    });
  }),
  Dice16: lazy(() => {
    return import('@plaid/icons/react/Dice16').then((module) => {
      return { default: module.Dice16 };
    });
  }),
  Dice18: lazy(() => {
    return import('@plaid/icons/react/Dice18').then((module) => {
      return { default: module.Dice18 };
    });
  }),
  Dice20: lazy(() => {
    return import('@plaid/icons/react/Dice20').then((module) => {
      return { default: module.Dice20 };
    });
  }),
  Docs12: lazy(() => {
    return import('@plaid/icons/react/Docs12').then((module) => {
      return { default: module.Docs12 };
    });
  }),
  Docs14: lazy(() => {
    return import('@plaid/icons/react/Docs14').then((module) => {
      return { default: module.Docs14 };
    });
  }),
  Docs16: lazy(() => {
    return import('@plaid/icons/react/Docs16').then((module) => {
      return { default: module.Docs16 };
    });
  }),
  Docs18: lazy(() => {
    return import('@plaid/icons/react/Docs18').then((module) => {
      return { default: module.Docs18 };
    });
  }),
  Docs20: lazy(() => {
    return import('@plaid/icons/react/Docs20').then((module) => {
      return { default: module.Docs20 };
    });
  }),
  Document12: lazy(() => {
    return import('@plaid/icons/react/Document12').then((module) => {
      return { default: module.Document12 };
    });
  }),
  Document14: lazy(() => {
    return import('@plaid/icons/react/Document14').then((module) => {
      return { default: module.Document14 };
    });
  }),
  Document16: lazy(() => {
    return import('@plaid/icons/react/Document16').then((module) => {
      return { default: module.Document16 };
    });
  }),
  Document18: lazy(() => {
    return import('@plaid/icons/react/Document18').then((module) => {
      return { default: module.Document18 };
    });
  }),
  Document20: lazy(() => {
    return import('@plaid/icons/react/Document20').then((module) => {
      return { default: module.Document20 };
    });
  }),
  Download12: lazy(() => {
    return import('@plaid/icons/react/Download12').then((module) => {
      return { default: module.Download12 };
    });
  }),
  Download14: lazy(() => {
    return import('@plaid/icons/react/Download14').then((module) => {
      return { default: module.Download14 };
    });
  }),
  Download16: lazy(() => {
    return import('@plaid/icons/react/Download16').then((module) => {
      return { default: module.Download16 };
    });
  }),
  Download18: lazy(() => {
    return import('@plaid/icons/react/Download18').then((module) => {
      return { default: module.Download18 };
    });
  }),
  Download20: lazy(() => {
    return import('@plaid/icons/react/Download20').then((module) => {
      return { default: module.Download20 };
    });
  }),
  Edit12: lazy(() => {
    return import('@plaid/icons/react/Edit12').then((module) => {
      return { default: module.Edit12 };
    });
  }),
  Edit14: lazy(() => {
    return import('@plaid/icons/react/Edit14').then((module) => {
      return { default: module.Edit14 };
    });
  }),
  Edit16: lazy(() => {
    return import('@plaid/icons/react/Edit16').then((module) => {
      return { default: module.Edit16 };
    });
  }),
  Edit18: lazy(() => {
    return import('@plaid/icons/react/Edit18').then((module) => {
      return { default: module.Edit18 };
    });
  }),
  Edit20: lazy(() => {
    return import('@plaid/icons/react/Edit20').then((module) => {
      return { default: module.Edit20 };
    });
  }),
  Exclamation12: lazy(() => {
    return import('@plaid/icons/react/Exclamation12').then((module) => {
      return { default: module.Exclamation12 };
    });
  }),
  Exclamation14: lazy(() => {
    return import('@plaid/icons/react/Exclamation14').then((module) => {
      return { default: module.Exclamation14 };
    });
  }),
  Exclamation16: lazy(() => {
    return import('@plaid/icons/react/Exclamation16').then((module) => {
      return { default: module.Exclamation16 };
    });
  }),
  Exclamation18: lazy(() => {
    return import('@plaid/icons/react/Exclamation18').then((module) => {
      return { default: module.Exclamation18 };
    });
  }),
  Exclamation20: lazy(() => {
    return import('@plaid/icons/react/Exclamation20').then((module) => {
      return { default: module.Exclamation20 };
    });
  }),
  External12: lazy(() => {
    return import('@plaid/icons/react/External12').then((module) => {
      return { default: module.External12 };
    });
  }),
  External14: lazy(() => {
    return import('@plaid/icons/react/External14').then((module) => {
      return { default: module.External14 };
    });
  }),
  External16: lazy(() => {
    return import('@plaid/icons/react/External16').then((module) => {
      return { default: module.External16 };
    });
  }),
  External18: lazy(() => {
    return import('@plaid/icons/react/External18').then((module) => {
      return { default: module.External18 };
    });
  }),
  External20: lazy(() => {
    return import('@plaid/icons/react/External20').then((module) => {
      return { default: module.External20 };
    });
  }),
  Folder12: lazy(() => {
    return import('@plaid/icons/react/Folder12').then((module) => {
      return { default: module.Folder12 };
    });
  }),
  Folder14: lazy(() => {
    return import('@plaid/icons/react/Folder14').then((module) => {
      return { default: module.Folder14 };
    });
  }),
  Folder16: lazy(() => {
    return import('@plaid/icons/react/Folder16').then((module) => {
      return { default: module.Folder16 };
    });
  }),
  Folder18: lazy(() => {
    return import('@plaid/icons/react/Folder18').then((module) => {
      return { default: module.Folder18 };
    });
  }),
  Folder20: lazy(() => {
    return import('@plaid/icons/react/Folder20').then((module) => {
      return { default: module.Folder20 };
    });
  }),
  FraudRing12: lazy(() => {
    return import('@plaid/icons/react/FraudRing12').then((module) => {
      return { default: module.FraudRing12 };
    });
  }),
  FraudRing14: lazy(() => {
    return import('@plaid/icons/react/FraudRing14').then((module) => {
      return { default: module.FraudRing14 };
    });
  }),
  FraudRing16: lazy(() => {
    return import('@plaid/icons/react/FraudRing16').then((module) => {
      return { default: module.FraudRing16 };
    });
  }),
  FraudRing18: lazy(() => {
    return import('@plaid/icons/react/FraudRing18').then((module) => {
      return { default: module.FraudRing18 };
    });
  }),
  FraudRing20: lazy(() => {
    return import('@plaid/icons/react/FraudRing20').then((module) => {
      return { default: module.FraudRing20 };
    });
  }),
  Fraudster12: lazy(() => {
    return import('@plaid/icons/react/Fraudster12').then((module) => {
      return { default: module.Fraudster12 };
    });
  }),
  Fraudster14: lazy(() => {
    return import('@plaid/icons/react/Fraudster14').then((module) => {
      return { default: module.Fraudster14 };
    });
  }),
  Fraudster16: lazy(() => {
    return import('@plaid/icons/react/Fraudster16').then((module) => {
      return { default: module.Fraudster16 };
    });
  }),
  Fraudster18: lazy(() => {
    return import('@plaid/icons/react/Fraudster18').then((module) => {
      return { default: module.Fraudster18 };
    });
  }),
  Fraudster20: lazy(() => {
    return import('@plaid/icons/react/Fraudster20').then((module) => {
      return { default: module.Fraudster20 };
    });
  }),
  Gear12: lazy(() => {
    return import('@plaid/icons/react/Gear12').then((module) => {
      return { default: module.Gear12 };
    });
  }),
  Gear14: lazy(() => {
    return import('@plaid/icons/react/Gear14').then((module) => {
      return { default: module.Gear14 };
    });
  }),
  Gear16: lazy(() => {
    return import('@plaid/icons/react/Gear16').then((module) => {
      return { default: module.Gear16 };
    });
  }),
  Gear18: lazy(() => {
    return import('@plaid/icons/react/Gear18').then((module) => {
      return { default: module.Gear18 };
    });
  }),
  Gear20: lazy(() => {
    return import('@plaid/icons/react/Gear20').then((module) => {
      return { default: module.Gear20 };
    });
  }),
  Globe12: lazy(() => {
    return import('@plaid/icons/react/Globe12').then((module) => {
      return { default: module.Globe12 };
    });
  }),
  Globe14: lazy(() => {
    return import('@plaid/icons/react/Globe14').then((module) => {
      return { default: module.Globe14 };
    });
  }),
  Globe16: lazy(() => {
    return import('@plaid/icons/react/Globe16').then((module) => {
      return { default: module.Globe16 };
    });
  }),
  Globe18: lazy(() => {
    return import('@plaid/icons/react/Globe18').then((module) => {
      return { default: module.Globe18 };
    });
  }),
  Globe20: lazy(() => {
    return import('@plaid/icons/react/Globe20').then((module) => {
      return { default: module.Globe20 };
    });
  }),
  Guide12: lazy(() => {
    return import('@plaid/icons/react/Guide12').then((module) => {
      return { default: module.Guide12 };
    });
  }),
  Guide14: lazy(() => {
    return import('@plaid/icons/react/Guide14').then((module) => {
      return { default: module.Guide14 };
    });
  }),
  Guide16: lazy(() => {
    return import('@plaid/icons/react/Guide16').then((module) => {
      return { default: module.Guide16 };
    });
  }),
  Guide18: lazy(() => {
    return import('@plaid/icons/react/Guide18').then((module) => {
      return { default: module.Guide18 };
    });
  }),
  Guide20: lazy(() => {
    return import('@plaid/icons/react/Guide20').then((module) => {
      return { default: module.Guide20 };
    });
  }),
  Hand12: lazy(() => {
    return import('@plaid/icons/react/Hand12').then((module) => {
      return { default: module.Hand12 };
    });
  }),
  Hand14: lazy(() => {
    return import('@plaid/icons/react/Hand14').then((module) => {
      return { default: module.Hand14 };
    });
  }),
  Hand16: lazy(() => {
    return import('@plaid/icons/react/Hand16').then((module) => {
      return { default: module.Hand16 };
    });
  }),
  Hand18: lazy(() => {
    return import('@plaid/icons/react/Hand18').then((module) => {
      return { default: module.Hand18 };
    });
  }),
  Hand20: lazy(() => {
    return import('@plaid/icons/react/Hand20').then((module) => {
      return { default: module.Hand20 };
    });
  }),
  Hashtag12: lazy(() => {
    return import('@plaid/icons/react/Hashtag12').then((module) => {
      return { default: module.Hashtag12 };
    });
  }),
  Hashtag14: lazy(() => {
    return import('@plaid/icons/react/Hashtag14').then((module) => {
      return { default: module.Hashtag14 };
    });
  }),
  Hashtag16: lazy(() => {
    return import('@plaid/icons/react/Hashtag16').then((module) => {
      return { default: module.Hashtag16 };
    });
  }),
  Hashtag18: lazy(() => {
    return import('@plaid/icons/react/Hashtag18').then((module) => {
      return { default: module.Hashtag18 };
    });
  }),
  Hashtag20: lazy(() => {
    return import('@plaid/icons/react/Hashtag20').then((module) => {
      return { default: module.Hashtag20 };
    });
  }),
  Healthcare12: lazy(() => {
    return import('@plaid/icons/react/Healthcare12').then((module) => {
      return { default: module.Healthcare12 };
    });
  }),
  Healthcare14: lazy(() => {
    return import('@plaid/icons/react/Healthcare14').then((module) => {
      return { default: module.Healthcare14 };
    });
  }),
  Healthcare16: lazy(() => {
    return import('@plaid/icons/react/Healthcare16').then((module) => {
      return { default: module.Healthcare16 };
    });
  }),
  Healthcare18: lazy(() => {
    return import('@plaid/icons/react/Healthcare18').then((module) => {
      return { default: module.Healthcare18 };
    });
  }),
  Healthcare20: lazy(() => {
    return import('@plaid/icons/react/Healthcare20').then((module) => {
      return { default: module.Healthcare20 };
    });
  }),
  Heart12: lazy(() => {
    return import('@plaid/icons/react/Heart12').then((module) => {
      return { default: module.Heart12 };
    });
  }),
  Heart14: lazy(() => {
    return import('@plaid/icons/react/Heart14').then((module) => {
      return { default: module.Heart14 };
    });
  }),
  Heart16: lazy(() => {
    return import('@plaid/icons/react/Heart16').then((module) => {
      return { default: module.Heart16 };
    });
  }),
  Heart18: lazy(() => {
    return import('@plaid/icons/react/Heart18').then((module) => {
      return { default: module.Heart18 };
    });
  }),
  Heart20: lazy(() => {
    return import('@plaid/icons/react/Heart20').then((module) => {
      return { default: module.Heart20 };
    });
  }),
  Help12: lazy(() => {
    return import('@plaid/icons/react/Help12').then((module) => {
      return { default: module.Help12 };
    });
  }),
  Help14: lazy(() => {
    return import('@plaid/icons/react/Help14').then((module) => {
      return { default: module.Help14 };
    });
  }),
  Help16: lazy(() => {
    return import('@plaid/icons/react/Help16').then((module) => {
      return { default: module.Help16 };
    });
  }),
  Help18: lazy(() => {
    return import('@plaid/icons/react/Help18').then((module) => {
      return { default: module.Help18 };
    });
  }),
  Help20: lazy(() => {
    return import('@plaid/icons/react/Help20').then((module) => {
      return { default: module.Help20 };
    });
  }),
  Home12: lazy(() => {
    return import('@plaid/icons/react/Home12').then((module) => {
      return { default: module.Home12 };
    });
  }),
  Home14: lazy(() => {
    return import('@plaid/icons/react/Home14').then((module) => {
      return { default: module.Home14 };
    });
  }),
  Home16: lazy(() => {
    return import('@plaid/icons/react/Home16').then((module) => {
      return { default: module.Home16 };
    });
  }),
  Home18: lazy(() => {
    return import('@plaid/icons/react/Home18').then((module) => {
      return { default: module.Home18 };
    });
  }),
  Home20: lazy(() => {
    return import('@plaid/icons/react/Home20').then((module) => {
      return { default: module.Home20 };
    });
  }),
  IconPlaceholder12: lazy(() => {
    return import('@plaid/icons/react/IconPlaceholder12').then((module) => {
      return { default: module.IconPlaceholder12 };
    });
  }),
  IconPlaceholder14: lazy(() => {
    return import('@plaid/icons/react/IconPlaceholder14').then((module) => {
      return { default: module.IconPlaceholder14 };
    });
  }),
  IconPlaceholder16: lazy(() => {
    return import('@plaid/icons/react/IconPlaceholder16').then((module) => {
      return { default: module.IconPlaceholder16 };
    });
  }),
  IconPlaceholder18: lazy(() => {
    return import('@plaid/icons/react/IconPlaceholder18').then((module) => {
      return { default: module.IconPlaceholder18 };
    });
  }),
  IconPlaceholder20: lazy(() => {
    return import('@plaid/icons/react/IconPlaceholder20').then((module) => {
      return { default: module.IconPlaceholder20 };
    });
  }),
  Id12: lazy(() => {
    return import('@plaid/icons/react/Id12').then((module) => {
      return { default: module.Id12 };
    });
  }),
  Id14: lazy(() => {
    return import('@plaid/icons/react/Id14').then((module) => {
      return { default: module.Id14 };
    });
  }),
  Id16: lazy(() => {
    return import('@plaid/icons/react/Id16').then((module) => {
      return { default: module.Id16 };
    });
  }),
  Id18: lazy(() => {
    return import('@plaid/icons/react/Id18').then((module) => {
      return { default: module.Id18 };
    });
  }),
  Id20: lazy(() => {
    return import('@plaid/icons/react/Id20').then((module) => {
      return { default: module.Id20 };
    });
  }),
  Identity12: lazy(() => {
    return import('@plaid/icons/react/Identity12').then((module) => {
      return { default: module.Identity12 };
    });
  }),
  Identity14: lazy(() => {
    return import('@plaid/icons/react/Identity14').then((module) => {
      return { default: module.Identity14 };
    });
  }),
  Identity16: lazy(() => {
    return import('@plaid/icons/react/Identity16').then((module) => {
      return { default: module.Identity16 };
    });
  }),
  Identity18: lazy(() => {
    return import('@plaid/icons/react/Identity18').then((module) => {
      return { default: module.Identity18 };
    });
  }),
  Identity20: lazy(() => {
    return import('@plaid/icons/react/Identity20').then((module) => {
      return { default: module.Identity20 };
    });
  }),
  Inbox12: lazy(() => {
    return import('@plaid/icons/react/Inbox12').then((module) => {
      return { default: module.Inbox12 };
    });
  }),
  Inbox14: lazy(() => {
    return import('@plaid/icons/react/Inbox14').then((module) => {
      return { default: module.Inbox14 };
    });
  }),
  Inbox16: lazy(() => {
    return import('@plaid/icons/react/Inbox16').then((module) => {
      return { default: module.Inbox16 };
    });
  }),
  Inbox18: lazy(() => {
    return import('@plaid/icons/react/Inbox18').then((module) => {
      return { default: module.Inbox18 };
    });
  }),
  Inbox20: lazy(() => {
    return import('@plaid/icons/react/Inbox20').then((module) => {
      return { default: module.Inbox20 };
    });
  }),
  Income12: lazy(() => {
    return import('@plaid/icons/react/Income12').then((module) => {
      return { default: module.Income12 };
    });
  }),
  Income14: lazy(() => {
    return import('@plaid/icons/react/Income14').then((module) => {
      return { default: module.Income14 };
    });
  }),
  Income16: lazy(() => {
    return import('@plaid/icons/react/Income16').then((module) => {
      return { default: module.Income16 };
    });
  }),
  Income18: lazy(() => {
    return import('@plaid/icons/react/Income18').then((module) => {
      return { default: module.Income18 };
    });
  }),
  Income20: lazy(() => {
    return import('@plaid/icons/react/Income20').then((module) => {
      return { default: module.Income20 };
    });
  }),
  Incomplete12: lazy(() => {
    return import('@plaid/icons/react/Incomplete12').then((module) => {
      return { default: module.Incomplete12 };
    });
  }),
  Incomplete14: lazy(() => {
    return import('@plaid/icons/react/Incomplete14').then((module) => {
      return { default: module.Incomplete14 };
    });
  }),
  Incomplete16: lazy(() => {
    return import('@plaid/icons/react/Incomplete16').then((module) => {
      return { default: module.Incomplete16 };
    });
  }),
  Incomplete18: lazy(() => {
    return import('@plaid/icons/react/Incomplete18').then((module) => {
      return { default: module.Incomplete18 };
    });
  }),
  Incomplete20: lazy(() => {
    return import('@plaid/icons/react/Incomplete20').then((module) => {
      return { default: module.Incomplete20 };
    });
  }),
  Information12: lazy(() => {
    return import('@plaid/icons/react/Information12').then((module) => {
      return { default: module.Information12 };
    });
  }),
  Information14: lazy(() => {
    return import('@plaid/icons/react/Information14').then((module) => {
      return { default: module.Information14 };
    });
  }),
  Information16: lazy(() => {
    return import('@plaid/icons/react/Information16').then((module) => {
      return { default: module.Information16 };
    });
  }),
  Information18: lazy(() => {
    return import('@plaid/icons/react/Information18').then((module) => {
      return { default: module.Information18 };
    });
  }),
  Information20: lazy(() => {
    return import('@plaid/icons/react/Information20').then((module) => {
      return { default: module.Information20 };
    });
  }),
  Institution12: lazy(() => {
    return import('@plaid/icons/react/Institution12').then((module) => {
      return { default: module.Institution12 };
    });
  }),
  Institution14: lazy(() => {
    return import('@plaid/icons/react/Institution14').then((module) => {
      return { default: module.Institution14 };
    });
  }),
  Institution16: lazy(() => {
    return import('@plaid/icons/react/Institution16').then((module) => {
      return { default: module.Institution16 };
    });
  }),
  Institution18: lazy(() => {
    return import('@plaid/icons/react/Institution18').then((module) => {
      return { default: module.Institution18 };
    });
  }),
  Institution20: lazy(() => {
    return import('@plaid/icons/react/Institution20').then((module) => {
      return { default: module.Institution20 };
    });
  }),
  Insurance12: lazy(() => {
    return import('@plaid/icons/react/Insurance12').then((module) => {
      return { default: module.Insurance12 };
    });
  }),
  Insurance14: lazy(() => {
    return import('@plaid/icons/react/Insurance14').then((module) => {
      return { default: module.Insurance14 };
    });
  }),
  Insurance16: lazy(() => {
    return import('@plaid/icons/react/Insurance16').then((module) => {
      return { default: module.Insurance16 };
    });
  }),
  Insurance18: lazy(() => {
    return import('@plaid/icons/react/Insurance18').then((module) => {
      return { default: module.Insurance18 };
    });
  }),
  Insurance20: lazy(() => {
    return import('@plaid/icons/react/Insurance20').then((module) => {
      return { default: module.Insurance20 };
    });
  }),
  Integrations12: lazy(() => {
    return import('@plaid/icons/react/Integrations12').then((module) => {
      return { default: module.Integrations12 };
    });
  }),
  Integrations14: lazy(() => {
    return import('@plaid/icons/react/Integrations14').then((module) => {
      return { default: module.Integrations14 };
    });
  }),
  Integrations16: lazy(() => {
    return import('@plaid/icons/react/Integrations16').then((module) => {
      return { default: module.Integrations16 };
    });
  }),
  Integrations18: lazy(() => {
    return import('@plaid/icons/react/Integrations18').then((module) => {
      return { default: module.Integrations18 };
    });
  }),
  Integrations20: lazy(() => {
    return import('@plaid/icons/react/Integrations20').then((module) => {
      return { default: module.Integrations20 };
    });
  }),
  ItemManagement12: lazy(() => {
    return import('@plaid/icons/react/ItemManagement12').then((module) => {
      return { default: module.ItemManagement12 };
    });
  }),
  ItemManagement14: lazy(() => {
    return import('@plaid/icons/react/ItemManagement14').then((module) => {
      return { default: module.ItemManagement14 };
    });
  }),
  ItemManagement16: lazy(() => {
    return import('@plaid/icons/react/ItemManagement16').then((module) => {
      return { default: module.ItemManagement16 };
    });
  }),
  ItemManagement18: lazy(() => {
    return import('@plaid/icons/react/ItemManagement18').then((module) => {
      return { default: module.ItemManagement18 };
    });
  }),
  ItemManagement20: lazy(() => {
    return import('@plaid/icons/react/ItemManagement20').then((module) => {
      return { default: module.ItemManagement20 };
    });
  }),
  Items12: lazy(() => {
    return import('@plaid/icons/react/Items12').then((module) => {
      return { default: module.Items12 };
    });
  }),
  Items14: lazy(() => {
    return import('@plaid/icons/react/Items14').then((module) => {
      return { default: module.Items14 };
    });
  }),
  Items16: lazy(() => {
    return import('@plaid/icons/react/Items16').then((module) => {
      return { default: module.Items16 };
    });
  }),
  Items18: lazy(() => {
    return import('@plaid/icons/react/Items18').then((module) => {
      return { default: module.Items18 };
    });
  }),
  Items20: lazy(() => {
    return import('@plaid/icons/react/Items20').then((module) => {
      return { default: module.Items20 };
    });
  }),
  Key12: lazy(() => {
    return import('@plaid/icons/react/Key12').then((module) => {
      return { default: module.Key12 };
    });
  }),
  Key14: lazy(() => {
    return import('@plaid/icons/react/Key14').then((module) => {
      return { default: module.Key14 };
    });
  }),
  Key16: lazy(() => {
    return import('@plaid/icons/react/Key16').then((module) => {
      return { default: module.Key16 };
    });
  }),
  Key18: lazy(() => {
    return import('@plaid/icons/react/Key18').then((module) => {
      return { default: module.Key18 };
    });
  }),
  Key20: lazy(() => {
    return import('@plaid/icons/react/Key20').then((module) => {
      return { default: module.Key20 };
    });
  }),
  Learn12: lazy(() => {
    return import('@plaid/icons/react/Learn12').then((module) => {
      return { default: module.Learn12 };
    });
  }),
  Learn14: lazy(() => {
    return import('@plaid/icons/react/Learn14').then((module) => {
      return { default: module.Learn14 };
    });
  }),
  Learn16: lazy(() => {
    return import('@plaid/icons/react/Learn16').then((module) => {
      return { default: module.Learn16 };
    });
  }),
  Learn18: lazy(() => {
    return import('@plaid/icons/react/Learn18').then((module) => {
      return { default: module.Learn18 };
    });
  }),
  Learn20: lazy(() => {
    return import('@plaid/icons/react/Learn20').then((module) => {
      return { default: module.Learn20 };
    });
  }),
  Libraries12: lazy(() => {
    return import('@plaid/icons/react/Libraries12').then((module) => {
      return { default: module.Libraries12 };
    });
  }),
  Libraries14: lazy(() => {
    return import('@plaid/icons/react/Libraries14').then((module) => {
      return { default: module.Libraries14 };
    });
  }),
  Libraries16: lazy(() => {
    return import('@plaid/icons/react/Libraries16').then((module) => {
      return { default: module.Libraries16 };
    });
  }),
  Libraries18: lazy(() => {
    return import('@plaid/icons/react/Libraries18').then((module) => {
      return { default: module.Libraries18 };
    });
  }),
  Libraries20: lazy(() => {
    return import('@plaid/icons/react/Libraries20').then((module) => {
      return { default: module.Libraries20 };
    });
  }),
  Light12: lazy(() => {
    return import('@plaid/icons/react/Light12').then((module) => {
      return { default: module.Light12 };
    });
  }),
  Light14: lazy(() => {
    return import('@plaid/icons/react/Light14').then((module) => {
      return { default: module.Light14 };
    });
  }),
  Light16: lazy(() => {
    return import('@plaid/icons/react/Light16').then((module) => {
      return { default: module.Light16 };
    });
  }),
  Light18: lazy(() => {
    return import('@plaid/icons/react/Light18').then((module) => {
      return { default: module.Light18 };
    });
  }),
  Light20: lazy(() => {
    return import('@plaid/icons/react/Light20').then((module) => {
      return { default: module.Light20 };
    });
  }),
  Lightbulb12: lazy(() => {
    return import('@plaid/icons/react/Lightbulb12').then((module) => {
      return { default: module.Lightbulb12 };
    });
  }),
  Lightbulb14: lazy(() => {
    return import('@plaid/icons/react/Lightbulb14').then((module) => {
      return { default: module.Lightbulb14 };
    });
  }),
  Lightbulb16: lazy(() => {
    return import('@plaid/icons/react/Lightbulb16').then((module) => {
      return { default: module.Lightbulb16 };
    });
  }),
  Lightbulb18: lazy(() => {
    return import('@plaid/icons/react/Lightbulb18').then((module) => {
      return { default: module.Lightbulb18 };
    });
  }),
  Lightbulb20: lazy(() => {
    return import('@plaid/icons/react/Lightbulb20').then((module) => {
      return { default: module.Lightbulb20 };
    });
  }),
  Lightning12: lazy(() => {
    return import('@plaid/icons/react/Lightning12').then((module) => {
      return { default: module.Lightning12 };
    });
  }),
  Lightning14: lazy(() => {
    return import('@plaid/icons/react/Lightning14').then((module) => {
      return { default: module.Lightning14 };
    });
  }),
  Lightning16: lazy(() => {
    return import('@plaid/icons/react/Lightning16').then((module) => {
      return { default: module.Lightning16 };
    });
  }),
  Lightning18: lazy(() => {
    return import('@plaid/icons/react/Lightning18').then((module) => {
      return { default: module.Lightning18 };
    });
  }),
  Lightning20: lazy(() => {
    return import('@plaid/icons/react/Lightning20').then((module) => {
      return { default: module.Lightning20 };
    });
  }),
  LightningFilled12: lazy(() => {
    return import('@plaid/icons/react/LightningFilled12').then((module) => {
      return { default: module.LightningFilled12 };
    });
  }),
  LightningFilled14: lazy(() => {
    return import('@plaid/icons/react/LightningFilled14').then((module) => {
      return { default: module.LightningFilled14 };
    });
  }),
  LightningFilled16: lazy(() => {
    return import('@plaid/icons/react/LightningFilled16').then((module) => {
      return { default: module.LightningFilled16 };
    });
  }),
  LightningFilled18: lazy(() => {
    return import('@plaid/icons/react/LightningFilled18').then((module) => {
      return { default: module.LightningFilled18 };
    });
  }),
  LightningFilled20: lazy(() => {
    return import('@plaid/icons/react/LightningFilled20').then((module) => {
      return { default: module.LightningFilled20 };
    });
  }),
  LineGraph12: lazy(() => {
    return import('@plaid/icons/react/LineGraph12').then((module) => {
      return { default: module.LineGraph12 };
    });
  }),
  LineGraph14: lazy(() => {
    return import('@plaid/icons/react/LineGraph14').then((module) => {
      return { default: module.LineGraph14 };
    });
  }),
  LineGraph16: lazy(() => {
    return import('@plaid/icons/react/LineGraph16').then((module) => {
      return { default: module.LineGraph16 };
    });
  }),
  LineGraph18: lazy(() => {
    return import('@plaid/icons/react/LineGraph18').then((module) => {
      return { default: module.LineGraph18 };
    });
  }),
  LineGraph20: lazy(() => {
    return import('@plaid/icons/react/LineGraph20').then((module) => {
      return { default: module.LineGraph20 };
    });
  }),
  Link12: lazy(() => {
    return import('@plaid/icons/react/Link12').then((module) => {
      return { default: module.Link12 };
    });
  }),
  Link14: lazy(() => {
    return import('@plaid/icons/react/Link14').then((module) => {
      return { default: module.Link14 };
    });
  }),
  Link16: lazy(() => {
    return import('@plaid/icons/react/Link16').then((module) => {
      return { default: module.Link16 };
    });
  }),
  Link18: lazy(() => {
    return import('@plaid/icons/react/Link18').then((module) => {
      return { default: module.Link18 };
    });
  }),
  Link20: lazy(() => {
    return import('@plaid/icons/react/Link20').then((module) => {
      return { default: module.Link20 };
    });
  }),
  List12: lazy(() => {
    return import('@plaid/icons/react/List12').then((module) => {
      return { default: module.List12 };
    });
  }),
  List14: lazy(() => {
    return import('@plaid/icons/react/List14').then((module) => {
      return { default: module.List14 };
    });
  }),
  List16: lazy(() => {
    return import('@plaid/icons/react/List16').then((module) => {
      return { default: module.List16 };
    });
  }),
  List18: lazy(() => {
    return import('@plaid/icons/react/List18').then((module) => {
      return { default: module.List18 };
    });
  }),
  List20: lazy(() => {
    return import('@plaid/icons/react/List20').then((module) => {
      return { default: module.List20 };
    });
  }),
  Lock12: lazy(() => {
    return import('@plaid/icons/react/Lock12').then((module) => {
      return { default: module.Lock12 };
    });
  }),
  Lock14: lazy(() => {
    return import('@plaid/icons/react/Lock14').then((module) => {
      return { default: module.Lock14 };
    });
  }),
  Lock16: lazy(() => {
    return import('@plaid/icons/react/Lock16').then((module) => {
      return { default: module.Lock16 };
    });
  }),
  Lock18: lazy(() => {
    return import('@plaid/icons/react/Lock18').then((module) => {
      return { default: module.Lock18 };
    });
  }),
  Lock20: lazy(() => {
    return import('@plaid/icons/react/Lock20').then((module) => {
      return { default: module.Lock20 };
    });
  }),
  Login12: lazy(() => {
    return import('@plaid/icons/react/Login12').then((module) => {
      return { default: module.Login12 };
    });
  }),
  Login14: lazy(() => {
    return import('@plaid/icons/react/Login14').then((module) => {
      return { default: module.Login14 };
    });
  }),
  Login16: lazy(() => {
    return import('@plaid/icons/react/Login16').then((module) => {
      return { default: module.Login16 };
    });
  }),
  Login18: lazy(() => {
    return import('@plaid/icons/react/Login18').then((module) => {
      return { default: module.Login18 };
    });
  }),
  Login20: lazy(() => {
    return import('@plaid/icons/react/Login20').then((module) => {
      return { default: module.Login20 };
    });
  }),
  Logout12: lazy(() => {
    return import('@plaid/icons/react/Logout12').then((module) => {
      return { default: module.Logout12 };
    });
  }),
  Logout14: lazy(() => {
    return import('@plaid/icons/react/Logout14').then((module) => {
      return { default: module.Logout14 };
    });
  }),
  Logout16: lazy(() => {
    return import('@plaid/icons/react/Logout16').then((module) => {
      return { default: module.Logout16 };
    });
  }),
  Logout18: lazy(() => {
    return import('@plaid/icons/react/Logout18').then((module) => {
      return { default: module.Logout18 };
    });
  }),
  Logout20: lazy(() => {
    return import('@plaid/icons/react/Logout20').then((module) => {
      return { default: module.Logout20 };
    });
  }),
  Mail12: lazy(() => {
    return import('@plaid/icons/react/Mail12').then((module) => {
      return { default: module.Mail12 };
    });
  }),
  Mail14: lazy(() => {
    return import('@plaid/icons/react/Mail14').then((module) => {
      return { default: module.Mail14 };
    });
  }),
  Mail16: lazy(() => {
    return import('@plaid/icons/react/Mail16').then((module) => {
      return { default: module.Mail16 };
    });
  }),
  Mail18: lazy(() => {
    return import('@plaid/icons/react/Mail18').then((module) => {
      return { default: module.Mail18 };
    });
  }),
  Mail20: lazy(() => {
    return import('@plaid/icons/react/Mail20').then((module) => {
      return { default: module.Mail20 };
    });
  }),
  Menu12: lazy(() => {
    return import('@plaid/icons/react/Menu12').then((module) => {
      return { default: module.Menu12 };
    });
  }),
  Menu14: lazy(() => {
    return import('@plaid/icons/react/Menu14').then((module) => {
      return { default: module.Menu14 };
    });
  }),
  Menu16: lazy(() => {
    return import('@plaid/icons/react/Menu16').then((module) => {
      return { default: module.Menu16 };
    });
  }),
  Menu18: lazy(() => {
    return import('@plaid/icons/react/Menu18').then((module) => {
      return { default: module.Menu18 };
    });
  }),
  Menu20: lazy(() => {
    return import('@plaid/icons/react/Menu20').then((module) => {
      return { default: module.Menu20 };
    });
  }),
  Message12: lazy(() => {
    return import('@plaid/icons/react/Message12').then((module) => {
      return { default: module.Message12 };
    });
  }),
  Message14: lazy(() => {
    return import('@plaid/icons/react/Message14').then((module) => {
      return { default: module.Message14 };
    });
  }),
  Message16: lazy(() => {
    return import('@plaid/icons/react/Message16').then((module) => {
      return { default: module.Message16 };
    });
  }),
  Message18: lazy(() => {
    return import('@plaid/icons/react/Message18').then((module) => {
      return { default: module.Message18 };
    });
  }),
  Message20: lazy(() => {
    return import('@plaid/icons/react/Message20').then((module) => {
      return { default: module.Message20 };
    });
  }),
  Mobile12: lazy(() => {
    return import('@plaid/icons/react/Mobile12').then((module) => {
      return { default: module.Mobile12 };
    });
  }),
  Mobile14: lazy(() => {
    return import('@plaid/icons/react/Mobile14').then((module) => {
      return { default: module.Mobile14 };
    });
  }),
  Mobile16: lazy(() => {
    return import('@plaid/icons/react/Mobile16').then((module) => {
      return { default: module.Mobile16 };
    });
  }),
  Mobile18: lazy(() => {
    return import('@plaid/icons/react/Mobile18').then((module) => {
      return { default: module.Mobile18 };
    });
  }),
  Mobile20: lazy(() => {
    return import('@plaid/icons/react/Mobile20').then((module) => {
      return { default: module.Mobile20 };
    });
  }),
  Moon12: lazy(() => {
    return import('@plaid/icons/react/Moon12').then((module) => {
      return { default: module.Moon12 };
    });
  }),
  Moon14: lazy(() => {
    return import('@plaid/icons/react/Moon14').then((module) => {
      return { default: module.Moon14 };
    });
  }),
  Moon16: lazy(() => {
    return import('@plaid/icons/react/Moon16').then((module) => {
      return { default: module.Moon16 };
    });
  }),
  Moon18: lazy(() => {
    return import('@plaid/icons/react/Moon18').then((module) => {
      return { default: module.Moon18 };
    });
  }),
  Moon20: lazy(() => {
    return import('@plaid/icons/react/Moon20').then((module) => {
      return { default: module.Moon20 };
    });
  }),
  NewWindow12: lazy(() => {
    return import('@plaid/icons/react/NewWindow12').then((module) => {
      return { default: module.NewWindow12 };
    });
  }),
  NewWindow14: lazy(() => {
    return import('@plaid/icons/react/NewWindow14').then((module) => {
      return { default: module.NewWindow14 };
    });
  }),
  NewWindow16: lazy(() => {
    return import('@plaid/icons/react/NewWindow16').then((module) => {
      return { default: module.NewWindow16 };
    });
  }),
  NewWindow18: lazy(() => {
    return import('@plaid/icons/react/NewWindow18').then((module) => {
      return { default: module.NewWindow18 };
    });
  }),
  NewWindow20: lazy(() => {
    return import('@plaid/icons/react/NewWindow20').then((module) => {
      return { default: module.NewWindow20 };
    });
  }),
  Notebook12: lazy(() => {
    return import('@plaid/icons/react/Notebook12').then((module) => {
      return { default: module.Notebook12 };
    });
  }),
  Notebook14: lazy(() => {
    return import('@plaid/icons/react/Notebook14').then((module) => {
      return { default: module.Notebook14 };
    });
  }),
  Notebook16: lazy(() => {
    return import('@plaid/icons/react/Notebook16').then((module) => {
      return { default: module.Notebook16 };
    });
  }),
  Notebook18: lazy(() => {
    return import('@plaid/icons/react/Notebook18').then((module) => {
      return { default: module.Notebook18 };
    });
  }),
  Notebook20: lazy(() => {
    return import('@plaid/icons/react/Notebook20').then((module) => {
      return { default: module.Notebook20 };
    });
  }),
  Overflow12: lazy(() => {
    return import('@plaid/icons/react/Overflow12').then((module) => {
      return { default: module.Overflow12 };
    });
  }),
  Overflow14: lazy(() => {
    return import('@plaid/icons/react/Overflow14').then((module) => {
      return { default: module.Overflow14 };
    });
  }),
  Overflow16: lazy(() => {
    return import('@plaid/icons/react/Overflow16').then((module) => {
      return { default: module.Overflow16 };
    });
  }),
  Overflow18: lazy(() => {
    return import('@plaid/icons/react/Overflow18').then((module) => {
      return { default: module.Overflow18 };
    });
  }),
  Overflow20: lazy(() => {
    return import('@plaid/icons/react/Overflow20').then((module) => {
      return { default: module.Overflow20 };
    });
  }),
  Override12: lazy(() => {
    return import('@plaid/icons/react/Override12').then((module) => {
      return { default: module.Override12 };
    });
  }),
  Override14: lazy(() => {
    return import('@plaid/icons/react/Override14').then((module) => {
      return { default: module.Override14 };
    });
  }),
  Override16: lazy(() => {
    return import('@plaid/icons/react/Override16').then((module) => {
      return { default: module.Override16 };
    });
  }),
  Override18: lazy(() => {
    return import('@plaid/icons/react/Override18').then((module) => {
      return { default: module.Override18 };
    });
  }),
  Override20: lazy(() => {
    return import('@plaid/icons/react/Override20').then((module) => {
      return { default: module.Override20 };
    });
  }),
  Overview12: lazy(() => {
    return import('@plaid/icons/react/Overview12').then((module) => {
      return { default: module.Overview12 };
    });
  }),
  Overview14: lazy(() => {
    return import('@plaid/icons/react/Overview14').then((module) => {
      return { default: module.Overview14 };
    });
  }),
  Overview16: lazy(() => {
    return import('@plaid/icons/react/Overview16').then((module) => {
      return { default: module.Overview16 };
    });
  }),
  Overview18: lazy(() => {
    return import('@plaid/icons/react/Overview18').then((module) => {
      return { default: module.Overview18 };
    });
  }),
  Overview20: lazy(() => {
    return import('@plaid/icons/react/Overview20').then((module) => {
      return { default: module.Overview20 };
    });
  }),
  Pause12: lazy(() => {
    return import('@plaid/icons/react/Pause12').then((module) => {
      return { default: module.Pause12 };
    });
  }),
  Pause14: lazy(() => {
    return import('@plaid/icons/react/Pause14').then((module) => {
      return { default: module.Pause14 };
    });
  }),
  Pause16: lazy(() => {
    return import('@plaid/icons/react/Pause16').then((module) => {
      return { default: module.Pause16 };
    });
  }),
  Pause18: lazy(() => {
    return import('@plaid/icons/react/Pause18').then((module) => {
      return { default: module.Pause18 };
    });
  }),
  Pause20: lazy(() => {
    return import('@plaid/icons/react/Pause20').then((module) => {
      return { default: module.Pause20 };
    });
  }),
  Phone12: lazy(() => {
    return import('@plaid/icons/react/Phone12').then((module) => {
      return { default: module.Phone12 };
    });
  }),
  Phone14: lazy(() => {
    return import('@plaid/icons/react/Phone14').then((module) => {
      return { default: module.Phone14 };
    });
  }),
  Phone16: lazy(() => {
    return import('@plaid/icons/react/Phone16').then((module) => {
      return { default: module.Phone16 };
    });
  }),
  Phone18: lazy(() => {
    return import('@plaid/icons/react/Phone18').then((module) => {
      return { default: module.Phone18 };
    });
  }),
  Phone20: lazy(() => {
    return import('@plaid/icons/react/Phone20').then((module) => {
      return { default: module.Phone20 };
    });
  }),
  PieChart12: lazy(() => {
    return import('@plaid/icons/react/PieChart12').then((module) => {
      return { default: module.PieChart12 };
    });
  }),
  PieChart14: lazy(() => {
    return import('@plaid/icons/react/PieChart14').then((module) => {
      return { default: module.PieChart14 };
    });
  }),
  PieChart16: lazy(() => {
    return import('@plaid/icons/react/PieChart16').then((module) => {
      return { default: module.PieChart16 };
    });
  }),
  PieChart18: lazy(() => {
    return import('@plaid/icons/react/PieChart18').then((module) => {
      return { default: module.PieChart18 };
    });
  }),
  PieChart20: lazy(() => {
    return import('@plaid/icons/react/PieChart20').then((module) => {
      return { default: module.PieChart20 };
    });
  }),
  Pin12: lazy(() => {
    return import('@plaid/icons/react/Pin12').then((module) => {
      return { default: module.Pin12 };
    });
  }),
  Pin14: lazy(() => {
    return import('@plaid/icons/react/Pin14').then((module) => {
      return { default: module.Pin14 };
    });
  }),
  Pin16: lazy(() => {
    return import('@plaid/icons/react/Pin16').then((module) => {
      return { default: module.Pin16 };
    });
  }),
  Pin18: lazy(() => {
    return import('@plaid/icons/react/Pin18').then((module) => {
      return { default: module.Pin18 };
    });
  }),
  Pin20: lazy(() => {
    return import('@plaid/icons/react/Pin20').then((module) => {
      return { default: module.Pin20 };
    });
  }),
  Platform12: lazy(() => {
    return import('@plaid/icons/react/Platform12').then((module) => {
      return { default: module.Platform12 };
    });
  }),
  Platform14: lazy(() => {
    return import('@plaid/icons/react/Platform14').then((module) => {
      return { default: module.Platform14 };
    });
  }),
  Platform16: lazy(() => {
    return import('@plaid/icons/react/Platform16').then((module) => {
      return { default: module.Platform16 };
    });
  }),
  Platform18: lazy(() => {
    return import('@plaid/icons/react/Platform18').then((module) => {
      return { default: module.Platform18 };
    });
  }),
  Platform20: lazy(() => {
    return import('@plaid/icons/react/Platform20').then((module) => {
      return { default: module.Platform20 };
    });
  }),
  Play12: lazy(() => {
    return import('@plaid/icons/react/Play12').then((module) => {
      return { default: module.Play12 };
    });
  }),
  Play14: lazy(() => {
    return import('@plaid/icons/react/Play14').then((module) => {
      return { default: module.Play14 };
    });
  }),
  Play16: lazy(() => {
    return import('@plaid/icons/react/Play16').then((module) => {
      return { default: module.Play16 };
    });
  }),
  Play18: lazy(() => {
    return import('@plaid/icons/react/Play18').then((module) => {
      return { default: module.Play18 };
    });
  }),
  Play20: lazy(() => {
    return import('@plaid/icons/react/Play20').then((module) => {
      return { default: module.Play20 };
    });
  }),
  ProductAuth12: lazy(() => {
    return import('@plaid/icons/react/ProductAuth12').then((module) => {
      return { default: module.ProductAuth12 };
    });
  }),
  ProductAuth14: lazy(() => {
    return import('@plaid/icons/react/ProductAuth14').then((module) => {
      return { default: module.ProductAuth14 };
    });
  }),
  ProductAuth16: lazy(() => {
    return import('@plaid/icons/react/ProductAuth16').then((module) => {
      return { default: module.ProductAuth16 };
    });
  }),
  ProductAuth18: lazy(() => {
    return import('@plaid/icons/react/ProductAuth18').then((module) => {
      return { default: module.ProductAuth18 };
    });
  }),
  ProductAuth20: lazy(() => {
    return import('@plaid/icons/react/ProductAuth20').then((module) => {
      return { default: module.ProductAuth20 };
    });
  }),
  ProductBeacon12: lazy(() => {
    return import('@plaid/icons/react/ProductBeacon12').then((module) => {
      return { default: module.ProductBeacon12 };
    });
  }),
  ProductBeacon14: lazy(() => {
    return import('@plaid/icons/react/ProductBeacon14').then((module) => {
      return { default: module.ProductBeacon14 };
    });
  }),
  ProductBeacon16: lazy(() => {
    return import('@plaid/icons/react/ProductBeacon16').then((module) => {
      return { default: module.ProductBeacon16 };
    });
  }),
  ProductBeacon18: lazy(() => {
    return import('@plaid/icons/react/ProductBeacon18').then((module) => {
      return { default: module.ProductBeacon18 };
    });
  }),
  ProductBeacon20: lazy(() => {
    return import('@plaid/icons/react/ProductBeacon20').then((module) => {
      return { default: module.ProductBeacon20 };
    });
  }),
  ProductIdv12: lazy(() => {
    return import('@plaid/icons/react/ProductIdv12').then((module) => {
      return { default: module.ProductIdv12 };
    });
  }),
  ProductIdv14: lazy(() => {
    return import('@plaid/icons/react/ProductIdv14').then((module) => {
      return { default: module.ProductIdv14 };
    });
  }),
  ProductIdv16: lazy(() => {
    return import('@plaid/icons/react/ProductIdv16').then((module) => {
      return { default: module.ProductIdv16 };
    });
  }),
  ProductIdv18: lazy(() => {
    return import('@plaid/icons/react/ProductIdv18').then((module) => {
      return { default: module.ProductIdv18 };
    });
  }),
  ProductIdv20: lazy(() => {
    return import('@plaid/icons/react/ProductIdv20').then((module) => {
      return { default: module.ProductIdv20 };
    });
  }),
  ProductLayer12: lazy(() => {
    return import('@plaid/icons/react/ProductLayer12').then((module) => {
      return { default: module.ProductLayer12 };
    });
  }),
  ProductLayer14: lazy(() => {
    return import('@plaid/icons/react/ProductLayer14').then((module) => {
      return { default: module.ProductLayer14 };
    });
  }),
  ProductLayer16: lazy(() => {
    return import('@plaid/icons/react/ProductLayer16').then((module) => {
      return { default: module.ProductLayer16 };
    });
  }),
  ProductLayer18: lazy(() => {
    return import('@plaid/icons/react/ProductLayer18').then((module) => {
      return { default: module.ProductLayer18 };
    });
  }),
  ProductLayer20: lazy(() => {
    return import('@plaid/icons/react/ProductLayer20').then((module) => {
      return { default: module.ProductLayer20 };
    });
  }),
  ProductMonitor12: lazy(() => {
    return import('@plaid/icons/react/ProductMonitor12').then((module) => {
      return { default: module.ProductMonitor12 };
    });
  }),
  ProductMonitor14: lazy(() => {
    return import('@plaid/icons/react/ProductMonitor14').then((module) => {
      return { default: module.ProductMonitor14 };
    });
  }),
  ProductMonitor16: lazy(() => {
    return import('@plaid/icons/react/ProductMonitor16').then((module) => {
      return { default: module.ProductMonitor16 };
    });
  }),
  ProductMonitor18: lazy(() => {
    return import('@plaid/icons/react/ProductMonitor18').then((module) => {
      return { default: module.ProductMonitor18 };
    });
  }),
  ProductMonitor20: lazy(() => {
    return import('@plaid/icons/react/ProductMonitor20').then((module) => {
      return { default: module.ProductMonitor20 };
    });
  }),
  ProductProtect12: lazy(() => {
    return import('@plaid/icons/react/ProductProtect12').then((module) => {
      return { default: module.ProductProtect12 };
    });
  }),
  ProductProtect14: lazy(() => {
    return import('@plaid/icons/react/ProductProtect14').then((module) => {
      return { default: module.ProductProtect14 };
    });
  }),
  ProductProtect16: lazy(() => {
    return import('@plaid/icons/react/ProductProtect16').then((module) => {
      return { default: module.ProductProtect16 };
    });
  }),
  ProductProtect18: lazy(() => {
    return import('@plaid/icons/react/ProductProtect18').then((module) => {
      return { default: module.ProductProtect18 };
    });
  }),
  ProductProtect20: lazy(() => {
    return import('@plaid/icons/react/ProductProtect20').then((module) => {
      return { default: module.ProductProtect20 };
    });
  }),
  Products12: lazy(() => {
    return import('@plaid/icons/react/Products12').then((module) => {
      return { default: module.Products12 };
    });
  }),
  Products14: lazy(() => {
    return import('@plaid/icons/react/Products14').then((module) => {
      return { default: module.Products14 };
    });
  }),
  Products16: lazy(() => {
    return import('@plaid/icons/react/Products16').then((module) => {
      return { default: module.Products16 };
    });
  }),
  Products18: lazy(() => {
    return import('@plaid/icons/react/Products18').then((module) => {
      return { default: module.Products18 };
    });
  }),
  Products20: lazy(() => {
    return import('@plaid/icons/react/Products20').then((module) => {
      return { default: module.Products20 };
    });
  }),
  ProductTransactions12: lazy(() => {
    return import('@plaid/icons/react/ProductTransactions12').then((module) => {
      return { default: module.ProductTransactions12 };
    });
  }),
  ProductTransactions14: lazy(() => {
    return import('@plaid/icons/react/ProductTransactions14').then((module) => {
      return { default: module.ProductTransactions14 };
    });
  }),
  ProductTransactions16: lazy(() => {
    return import('@plaid/icons/react/ProductTransactions16').then((module) => {
      return { default: module.ProductTransactions16 };
    });
  }),
  ProductTransactions18: lazy(() => {
    return import('@plaid/icons/react/ProductTransactions18').then((module) => {
      return { default: module.ProductTransactions18 };
    });
  }),
  ProductTransactions20: lazy(() => {
    return import('@plaid/icons/react/ProductTransactions20').then((module) => {
      return { default: module.ProductTransactions20 };
    });
  }),
  Progress12: lazy(() => {
    return import('@plaid/icons/react/Progress12').then((module) => {
      return { default: module.Progress12 };
    });
  }),
  Progress14: lazy(() => {
    return import('@plaid/icons/react/Progress14').then((module) => {
      return { default: module.Progress14 };
    });
  }),
  Progress16: lazy(() => {
    return import('@plaid/icons/react/Progress16').then((module) => {
      return { default: module.Progress16 };
    });
  }),
  Progress18: lazy(() => {
    return import('@plaid/icons/react/Progress18').then((module) => {
      return { default: module.Progress18 };
    });
  }),
  Progress20: lazy(() => {
    return import('@plaid/icons/react/Progress20').then((module) => {
      return { default: module.Progress20 };
    });
  }),
  Question12: lazy(() => {
    return import('@plaid/icons/react/Question12').then((module) => {
      return { default: module.Question12 };
    });
  }),
  Question14: lazy(() => {
    return import('@plaid/icons/react/Question14').then((module) => {
      return { default: module.Question14 };
    });
  }),
  Question16: lazy(() => {
    return import('@plaid/icons/react/Question16').then((module) => {
      return { default: module.Question16 };
    });
  }),
  Question18: lazy(() => {
    return import('@plaid/icons/react/Question18').then((module) => {
      return { default: module.Question18 };
    });
  }),
  Question20: lazy(() => {
    return import('@plaid/icons/react/Question20').then((module) => {
      return { default: module.Question20 };
    });
  }),
  Refresh12: lazy(() => {
    return import('@plaid/icons/react/Refresh12').then((module) => {
      return { default: module.Refresh12 };
    });
  }),
  Refresh14: lazy(() => {
    return import('@plaid/icons/react/Refresh14').then((module) => {
      return { default: module.Refresh14 };
    });
  }),
  Refresh16: lazy(() => {
    return import('@plaid/icons/react/Refresh16').then((module) => {
      return { default: module.Refresh16 };
    });
  }),
  Refresh18: lazy(() => {
    return import('@plaid/icons/react/Refresh18').then((module) => {
      return { default: module.Refresh18 };
    });
  }),
  Refresh20: lazy(() => {
    return import('@plaid/icons/react/Refresh20').then((module) => {
      return { default: module.Refresh20 };
    });
  }),
  RejectedRec12: lazy(() => {
    return import('@plaid/icons/react/RejectedRec12').then((module) => {
      return { default: module.RejectedRec12 };
    });
  }),
  RejectedRec14: lazy(() => {
    return import('@plaid/icons/react/RejectedRec14').then((module) => {
      return { default: module.RejectedRec14 };
    });
  }),
  RejectedRec16: lazy(() => {
    return import('@plaid/icons/react/RejectedRec16').then((module) => {
      return { default: module.RejectedRec16 };
    });
  }),
  RejectedRec18: lazy(() => {
    return import('@plaid/icons/react/RejectedRec18').then((module) => {
      return { default: module.RejectedRec18 };
    });
  }),
  RejectedRec20: lazy(() => {
    return import('@plaid/icons/react/RejectedRec20').then((module) => {
      return { default: module.RejectedRec20 };
    });
  }),
  Remove12: lazy(() => {
    return import('@plaid/icons/react/Remove12').then((module) => {
      return { default: module.Remove12 };
    });
  }),
  Remove14: lazy(() => {
    return import('@plaid/icons/react/Remove14').then((module) => {
      return { default: module.Remove14 };
    });
  }),
  Remove16: lazy(() => {
    return import('@plaid/icons/react/Remove16').then((module) => {
      return { default: module.Remove16 };
    });
  }),
  Remove18: lazy(() => {
    return import('@plaid/icons/react/Remove18').then((module) => {
      return { default: module.Remove18 };
    });
  }),
  Remove20: lazy(() => {
    return import('@plaid/icons/react/Remove20').then((module) => {
      return { default: module.Remove20 };
    });
  }),
  Reset12: lazy(() => {
    return import('@plaid/icons/react/Reset12').then((module) => {
      return { default: module.Reset12 };
    });
  }),
  Reset14: lazy(() => {
    return import('@plaid/icons/react/Reset14').then((module) => {
      return { default: module.Reset14 };
    });
  }),
  Reset16: lazy(() => {
    return import('@plaid/icons/react/Reset16').then((module) => {
      return { default: module.Reset16 };
    });
  }),
  Reset18: lazy(() => {
    return import('@plaid/icons/react/Reset18').then((module) => {
      return { default: module.Reset18 };
    });
  }),
  Reset20: lazy(() => {
    return import('@plaid/icons/react/Reset20').then((module) => {
      return { default: module.Reset20 };
    });
  }),
  Rocket12: lazy(() => {
    return import('@plaid/icons/react/Rocket12').then((module) => {
      return { default: module.Rocket12 };
    });
  }),
  Rocket14: lazy(() => {
    return import('@plaid/icons/react/Rocket14').then((module) => {
      return { default: module.Rocket14 };
    });
  }),
  Rocket16: lazy(() => {
    return import('@plaid/icons/react/Rocket16').then((module) => {
      return { default: module.Rocket16 };
    });
  }),
  Rocket18: lazy(() => {
    return import('@plaid/icons/react/Rocket18').then((module) => {
      return { default: module.Rocket18 };
    });
  }),
  Rocket20: lazy(() => {
    return import('@plaid/icons/react/Rocket20').then((module) => {
      return { default: module.Rocket20 };
    });
  }),
  Rotate12: lazy(() => {
    return import('@plaid/icons/react/Rotate12').then((module) => {
      return { default: module.Rotate12 };
    });
  }),
  Rotate14: lazy(() => {
    return import('@plaid/icons/react/Rotate14').then((module) => {
      return { default: module.Rotate14 };
    });
  }),
  Rotate16: lazy(() => {
    return import('@plaid/icons/react/Rotate16').then((module) => {
      return { default: module.Rotate16 };
    });
  }),
  Rotate18: lazy(() => {
    return import('@plaid/icons/react/Rotate18').then((module) => {
      return { default: module.Rotate18 };
    });
  }),
  Rotate20: lazy(() => {
    return import('@plaid/icons/react/Rotate20').then((module) => {
      return { default: module.Rotate20 };
    });
  }),
  Safe12: lazy(() => {
    return import('@plaid/icons/react/Safe12').then((module) => {
      return { default: module.Safe12 };
    });
  }),
  Safe14: lazy(() => {
    return import('@plaid/icons/react/Safe14').then((module) => {
      return { default: module.Safe14 };
    });
  }),
  Safe16: lazy(() => {
    return import('@plaid/icons/react/Safe16').then((module) => {
      return { default: module.Safe16 };
    });
  }),
  Safe18: lazy(() => {
    return import('@plaid/icons/react/Safe18').then((module) => {
      return { default: module.Safe18 };
    });
  }),
  Safe20: lazy(() => {
    return import('@plaid/icons/react/Safe20').then((module) => {
      return { default: module.Safe20 };
    });
  }),
  Sandbox12: lazy(() => {
    return import('@plaid/icons/react/Sandbox12').then((module) => {
      return { default: module.Sandbox12 };
    });
  }),
  Sandbox14: lazy(() => {
    return import('@plaid/icons/react/Sandbox14').then((module) => {
      return { default: module.Sandbox14 };
    });
  }),
  Sandbox16: lazy(() => {
    return import('@plaid/icons/react/Sandbox16').then((module) => {
      return { default: module.Sandbox16 };
    });
  }),
  Sandbox18: lazy(() => {
    return import('@plaid/icons/react/Sandbox18').then((module) => {
      return { default: module.Sandbox18 };
    });
  }),
  Sandbox20: lazy(() => {
    return import('@plaid/icons/react/Sandbox20').then((module) => {
      return { default: module.Sandbox20 };
    });
  }),
  Search12: lazy(() => {
    return import('@plaid/icons/react/Search12').then((module) => {
      return { default: module.Search12 };
    });
  }),
  Search14: lazy(() => {
    return import('@plaid/icons/react/Search14').then((module) => {
      return { default: module.Search14 };
    });
  }),
  Search16: lazy(() => {
    return import('@plaid/icons/react/Search16').then((module) => {
      return { default: module.Search16 };
    });
  }),
  Search18: lazy(() => {
    return import('@plaid/icons/react/Search18').then((module) => {
      return { default: module.Search18 };
    });
  }),
  Search20: lazy(() => {
    return import('@plaid/icons/react/Search20').then((module) => {
      return { default: module.Search20 };
    });
  }),
  SearchAlt12: lazy(() => {
    return import('@plaid/icons/react/SearchAlt12').then((module) => {
      return { default: module.SearchAlt12 };
    });
  }),
  SearchAlt14: lazy(() => {
    return import('@plaid/icons/react/SearchAlt14').then((module) => {
      return { default: module.SearchAlt14 };
    });
  }),
  SearchAlt16: lazy(() => {
    return import('@plaid/icons/react/SearchAlt16').then((module) => {
      return { default: module.SearchAlt16 };
    });
  }),
  SearchAlt18: lazy(() => {
    return import('@plaid/icons/react/SearchAlt18').then((module) => {
      return { default: module.SearchAlt18 };
    });
  }),
  SearchAlt20: lazy(() => {
    return import('@plaid/icons/react/SearchAlt20').then((module) => {
      return { default: module.SearchAlt20 };
    });
  }),
  Shield12: lazy(() => {
    return import('@plaid/icons/react/Shield12').then((module) => {
      return { default: module.Shield12 };
    });
  }),
  Shield14: lazy(() => {
    return import('@plaid/icons/react/Shield14').then((module) => {
      return { default: module.Shield14 };
    });
  }),
  Shield16: lazy(() => {
    return import('@plaid/icons/react/Shield16').then((module) => {
      return { default: module.Shield16 };
    });
  }),
  Shield18: lazy(() => {
    return import('@plaid/icons/react/Shield18').then((module) => {
      return { default: module.Shield18 };
    });
  }),
  Shield20: lazy(() => {
    return import('@plaid/icons/react/Shield20').then((module) => {
      return { default: module.Shield20 };
    });
  }),
  ShieldCaution12: lazy(() => {
    return import('@plaid/icons/react/ShieldCaution12').then((module) => {
      return { default: module.ShieldCaution12 };
    });
  }),
  ShieldCaution14: lazy(() => {
    return import('@plaid/icons/react/ShieldCaution14').then((module) => {
      return { default: module.ShieldCaution14 };
    });
  }),
  ShieldCaution16: lazy(() => {
    return import('@plaid/icons/react/ShieldCaution16').then((module) => {
      return { default: module.ShieldCaution16 };
    });
  }),
  ShieldCaution18: lazy(() => {
    return import('@plaid/icons/react/ShieldCaution18').then((module) => {
      return { default: module.ShieldCaution18 };
    });
  }),
  ShieldCaution20: lazy(() => {
    return import('@plaid/icons/react/ShieldCaution20').then((module) => {
      return { default: module.ShieldCaution20 };
    });
  }),
  SidebarHide12: lazy(() => {
    return import('@plaid/icons/react/SidebarHide12').then((module) => {
      return { default: module.SidebarHide12 };
    });
  }),
  SidebarHide14: lazy(() => {
    return import('@plaid/icons/react/SidebarHide14').then((module) => {
      return { default: module.SidebarHide14 };
    });
  }),
  SidebarHide16: lazy(() => {
    return import('@plaid/icons/react/SidebarHide16').then((module) => {
      return { default: module.SidebarHide16 };
    });
  }),
  SidebarHide18: lazy(() => {
    return import('@plaid/icons/react/SidebarHide18').then((module) => {
      return { default: module.SidebarHide18 };
    });
  }),
  SidebarHide20: lazy(() => {
    return import('@plaid/icons/react/SidebarHide20').then((module) => {
      return { default: module.SidebarHide20 };
    });
  }),
  SidebarShow12: lazy(() => {
    return import('@plaid/icons/react/SidebarShow12').then((module) => {
      return { default: module.SidebarShow12 };
    });
  }),
  SidebarShow14: lazy(() => {
    return import('@plaid/icons/react/SidebarShow14').then((module) => {
      return { default: module.SidebarShow14 };
    });
  }),
  SidebarShow16: lazy(() => {
    return import('@plaid/icons/react/SidebarShow16').then((module) => {
      return { default: module.SidebarShow16 };
    });
  }),
  SidebarShow18: lazy(() => {
    return import('@plaid/icons/react/SidebarShow18').then((module) => {
      return { default: module.SidebarShow18 };
    });
  }),
  SidebarShow20: lazy(() => {
    return import('@plaid/icons/react/SidebarShow20').then((module) => {
      return { default: module.SidebarShow20 };
    });
  }),
  StepComplete12: lazy(() => {
    return import('@plaid/icons/react/StepComplete12').then((module) => {
      return { default: module.StepComplete12 };
    });
  }),
  StepComplete14: lazy(() => {
    return import('@plaid/icons/react/StepComplete14').then((module) => {
      return { default: module.StepComplete14 };
    });
  }),
  StepComplete16: lazy(() => {
    return import('@plaid/icons/react/StepComplete16').then((module) => {
      return { default: module.StepComplete16 };
    });
  }),
  StepComplete18: lazy(() => {
    return import('@plaid/icons/react/StepComplete18').then((module) => {
      return { default: module.StepComplete18 };
    });
  }),
  StepComplete20: lazy(() => {
    return import('@plaid/icons/react/StepComplete20').then((module) => {
      return { default: module.StepComplete20 };
    });
  }),
  StepIncomplete12: lazy(() => {
    return import('@plaid/icons/react/StepIncomplete12').then((module) => {
      return { default: module.StepIncomplete12 };
    });
  }),
  StepIncomplete14: lazy(() => {
    return import('@plaid/icons/react/StepIncomplete14').then((module) => {
      return { default: module.StepIncomplete14 };
    });
  }),
  StepIncomplete16: lazy(() => {
    return import('@plaid/icons/react/StepIncomplete16').then((module) => {
      return { default: module.StepIncomplete16 };
    });
  }),
  StepIncomplete18: lazy(() => {
    return import('@plaid/icons/react/StepIncomplete18').then((module) => {
      return { default: module.StepIncomplete18 };
    });
  }),
  StepIncomplete20: lazy(() => {
    return import('@plaid/icons/react/StepIncomplete20').then((module) => {
      return { default: module.StepIncomplete20 };
    });
  }),
  StepInProgress12: lazy(() => {
    return import('@plaid/icons/react/StepInProgress12').then((module) => {
      return { default: module.StepInProgress12 };
    });
  }),
  StepInProgress14: lazy(() => {
    return import('@plaid/icons/react/StepInProgress14').then((module) => {
      return { default: module.StepInProgress14 };
    });
  }),
  StepInProgress16: lazy(() => {
    return import('@plaid/icons/react/StepInProgress16').then((module) => {
      return { default: module.StepInProgress16 };
    });
  }),
  StepInProgress18: lazy(() => {
    return import('@plaid/icons/react/StepInProgress18').then((module) => {
      return { default: module.StepInProgress18 };
    });
  }),
  StepInProgress20: lazy(() => {
    return import('@plaid/icons/react/StepInProgress20').then((module) => {
      return { default: module.StepInProgress20 };
    });
  }),
  Submit12: lazy(() => {
    return import('@plaid/icons/react/Submit12').then((module) => {
      return { default: module.Submit12 };
    });
  }),
  Submit14: lazy(() => {
    return import('@plaid/icons/react/Submit14').then((module) => {
      return { default: module.Submit14 };
    });
  }),
  Submit16: lazy(() => {
    return import('@plaid/icons/react/Submit16').then((module) => {
      return { default: module.Submit16 };
    });
  }),
  Submit18: lazy(() => {
    return import('@plaid/icons/react/Submit18').then((module) => {
      return { default: module.Submit18 };
    });
  }),
  Submit20: lazy(() => {
    return import('@plaid/icons/react/Submit20').then((module) => {
      return { default: module.Submit20 };
    });
  }),
  Subtract12: lazy(() => {
    return import('@plaid/icons/react/Subtract12').then((module) => {
      return { default: module.Subtract12 };
    });
  }),
  Subtract14: lazy(() => {
    return import('@plaid/icons/react/Subtract14').then((module) => {
      return { default: module.Subtract14 };
    });
  }),
  Subtract16: lazy(() => {
    return import('@plaid/icons/react/Subtract16').then((module) => {
      return { default: module.Subtract16 };
    });
  }),
  Subtract18: lazy(() => {
    return import('@plaid/icons/react/Subtract18').then((module) => {
      return { default: module.Subtract18 };
    });
  }),
  Subtract20: lazy(() => {
    return import('@plaid/icons/react/Subtract20').then((module) => {
      return { default: module.Subtract20 };
    });
  }),
  Switch12: lazy(() => {
    return import('@plaid/icons/react/Switch12').then((module) => {
      return { default: module.Switch12 };
    });
  }),
  Switch14: lazy(() => {
    return import('@plaid/icons/react/Switch14').then((module) => {
      return { default: module.Switch14 };
    });
  }),
  Switch16: lazy(() => {
    return import('@plaid/icons/react/Switch16').then((module) => {
      return { default: module.Switch16 };
    });
  }),
  Switch18: lazy(() => {
    return import('@plaid/icons/react/Switch18').then((module) => {
      return { default: module.Switch18 };
    });
  }),
  Switch20: lazy(() => {
    return import('@plaid/icons/react/Switch20').then((module) => {
      return { default: module.Switch20 };
    });
  }),
  Tag12: lazy(() => {
    return import('@plaid/icons/react/Tag12').then((module) => {
      return { default: module.Tag12 };
    });
  }),
  Tag14: lazy(() => {
    return import('@plaid/icons/react/Tag14').then((module) => {
      return { default: module.Tag14 };
    });
  }),
  Tag16: lazy(() => {
    return import('@plaid/icons/react/Tag16').then((module) => {
      return { default: module.Tag16 };
    });
  }),
  Tag18: lazy(() => {
    return import('@plaid/icons/react/Tag18').then((module) => {
      return { default: module.Tag18 };
    });
  }),
  Tag20: lazy(() => {
    return import('@plaid/icons/react/Tag20').then((module) => {
      return { default: module.Tag20 };
    });
  }),
  Terminal12: lazy(() => {
    return import('@plaid/icons/react/Terminal12').then((module) => {
      return { default: module.Terminal12 };
    });
  }),
  Terminal14: lazy(() => {
    return import('@plaid/icons/react/Terminal14').then((module) => {
      return { default: module.Terminal14 };
    });
  }),
  Terminal16: lazy(() => {
    return import('@plaid/icons/react/Terminal16').then((module) => {
      return { default: module.Terminal16 };
    });
  }),
  Terminal18: lazy(() => {
    return import('@plaid/icons/react/Terminal18').then((module) => {
      return { default: module.Terminal18 };
    });
  }),
  Terminal20: lazy(() => {
    return import('@plaid/icons/react/Terminal20').then((module) => {
      return { default: module.Terminal20 };
    });
  }),
  ThumbsDown12: lazy(() => {
    return import('@plaid/icons/react/ThumbsDown12').then((module) => {
      return { default: module.ThumbsDown12 };
    });
  }),
  ThumbsDown14: lazy(() => {
    return import('@plaid/icons/react/ThumbsDown14').then((module) => {
      return { default: module.ThumbsDown14 };
    });
  }),
  ThumbsDown16: lazy(() => {
    return import('@plaid/icons/react/ThumbsDown16').then((module) => {
      return { default: module.ThumbsDown16 };
    });
  }),
  ThumbsDown18: lazy(() => {
    return import('@plaid/icons/react/ThumbsDown18').then((module) => {
      return { default: module.ThumbsDown18 };
    });
  }),
  ThumbsDown20: lazy(() => {
    return import('@plaid/icons/react/ThumbsDown20').then((module) => {
      return { default: module.ThumbsDown20 };
    });
  }),
  ThumbsUp12: lazy(() => {
    return import('@plaid/icons/react/ThumbsUp12').then((module) => {
      return { default: module.ThumbsUp12 };
    });
  }),
  ThumbsUp14: lazy(() => {
    return import('@plaid/icons/react/ThumbsUp14').then((module) => {
      return { default: module.ThumbsUp14 };
    });
  }),
  ThumbsUp16: lazy(() => {
    return import('@plaid/icons/react/ThumbsUp16').then((module) => {
      return { default: module.ThumbsUp16 };
    });
  }),
  ThumbsUp18: lazy(() => {
    return import('@plaid/icons/react/ThumbsUp18').then((module) => {
      return { default: module.ThumbsUp18 };
    });
  }),
  ThumbsUp20: lazy(() => {
    return import('@plaid/icons/react/ThumbsUp20').then((module) => {
      return { default: module.ThumbsUp20 };
    });
  }),
  Transfer12: lazy(() => {
    return import('@plaid/icons/react/Transfer12').then((module) => {
      return { default: module.Transfer12 };
    });
  }),
  Transfer14: lazy(() => {
    return import('@plaid/icons/react/Transfer14').then((module) => {
      return { default: module.Transfer14 };
    });
  }),
  Transfer16: lazy(() => {
    return import('@plaid/icons/react/Transfer16').then((module) => {
      return { default: module.Transfer16 };
    });
  }),
  Transfer18: lazy(() => {
    return import('@plaid/icons/react/Transfer18').then((module) => {
      return { default: module.Transfer18 };
    });
  }),
  Transfer20: lazy(() => {
    return import('@plaid/icons/react/Transfer20').then((module) => {
      return { default: module.Transfer20 };
    });
  }),
  Trash12: lazy(() => {
    return import('@plaid/icons/react/Trash12').then((module) => {
      return { default: module.Trash12 };
    });
  }),
  Trash14: lazy(() => {
    return import('@plaid/icons/react/Trash14').then((module) => {
      return { default: module.Trash14 };
    });
  }),
  Trash16: lazy(() => {
    return import('@plaid/icons/react/Trash16').then((module) => {
      return { default: module.Trash16 };
    });
  }),
  Trash18: lazy(() => {
    return import('@plaid/icons/react/Trash18').then((module) => {
      return { default: module.Trash18 };
    });
  }),
  Trash20: lazy(() => {
    return import('@plaid/icons/react/Trash20').then((module) => {
      return { default: module.Trash20 };
    });
  }),
  Tweet12: lazy(() => {
    return import('@plaid/icons/react/Tweet12').then((module) => {
      return { default: module.Tweet12 };
    });
  }),
  Tweet14: lazy(() => {
    return import('@plaid/icons/react/Tweet14').then((module) => {
      return { default: module.Tweet14 };
    });
  }),
  Tweet16: lazy(() => {
    return import('@plaid/icons/react/Tweet16').then((module) => {
      return { default: module.Tweet16 };
    });
  }),
  Tweet18: lazy(() => {
    return import('@plaid/icons/react/Tweet18').then((module) => {
      return { default: module.Tweet18 };
    });
  }),
  Tweet20: lazy(() => {
    return import('@plaid/icons/react/Tweet20').then((module) => {
      return { default: module.Tweet20 };
    });
  }),
  Upload12: lazy(() => {
    return import('@plaid/icons/react/Upload12').then((module) => {
      return { default: module.Upload12 };
    });
  }),
  Upload14: lazy(() => {
    return import('@plaid/icons/react/Upload14').then((module) => {
      return { default: module.Upload14 };
    });
  }),
  Upload16: lazy(() => {
    return import('@plaid/icons/react/Upload16').then((module) => {
      return { default: module.Upload16 };
    });
  }),
  Upload18: lazy(() => {
    return import('@plaid/icons/react/Upload18').then((module) => {
      return { default: module.Upload18 };
    });
  }),
  Upload20: lazy(() => {
    return import('@plaid/icons/react/Upload20').then((module) => {
      return { default: module.Upload20 };
    });
  }),
  User12: lazy(() => {
    return import('@plaid/icons/react/User12').then((module) => {
      return { default: module.User12 };
    });
  }),
  User14: lazy(() => {
    return import('@plaid/icons/react/User14').then((module) => {
      return { default: module.User14 };
    });
  }),
  User16: lazy(() => {
    return import('@plaid/icons/react/User16').then((module) => {
      return { default: module.User16 };
    });
  }),
  User18: lazy(() => {
    return import('@plaid/icons/react/User18').then((module) => {
      return { default: module.User18 };
    });
  }),
  User20: lazy(() => {
    return import('@plaid/icons/react/User20').then((module) => {
      return { default: module.User20 };
    });
  }),
  Users12: lazy(() => {
    return import('@plaid/icons/react/Users12').then((module) => {
      return { default: module.Users12 };
    });
  }),
  Users14: lazy(() => {
    return import('@plaid/icons/react/Users14').then((module) => {
      return { default: module.Users14 };
    });
  }),
  Users16: lazy(() => {
    return import('@plaid/icons/react/Users16').then((module) => {
      return { default: module.Users16 };
    });
  }),
  Users18: lazy(() => {
    return import('@plaid/icons/react/Users18').then((module) => {
      return { default: module.Users18 };
    });
  }),
  Users20: lazy(() => {
    return import('@plaid/icons/react/Users20').then((module) => {
      return { default: module.Users20 };
    });
  }),
  Video12: lazy(() => {
    return import('@plaid/icons/react/Video12').then((module) => {
      return { default: module.Video12 };
    });
  }),
  Video14: lazy(() => {
    return import('@plaid/icons/react/Video14').then((module) => {
      return { default: module.Video14 };
    });
  }),
  Video16: lazy(() => {
    return import('@plaid/icons/react/Video16').then((module) => {
      return { default: module.Video16 };
    });
  }),
  Video18: lazy(() => {
    return import('@plaid/icons/react/Video18').then((module) => {
      return { default: module.Video18 };
    });
  }),
  Video20: lazy(() => {
    return import('@plaid/icons/react/Video20').then((module) => {
      return { default: module.Video20 };
    });
  }),
  Wallet12: lazy(() => {
    return import('@plaid/icons/react/Wallet12').then((module) => {
      return { default: module.Wallet12 };
    });
  }),
  Wallet14: lazy(() => {
    return import('@plaid/icons/react/Wallet14').then((module) => {
      return { default: module.Wallet14 };
    });
  }),
  Wallet16: lazy(() => {
    return import('@plaid/icons/react/Wallet16').then((module) => {
      return { default: module.Wallet16 };
    });
  }),
  Wallet18: lazy(() => {
    return import('@plaid/icons/react/Wallet18').then((module) => {
      return { default: module.Wallet18 };
    });
  }),
  Wallet20: lazy(() => {
    return import('@plaid/icons/react/Wallet20').then((module) => {
      return { default: module.Wallet20 };
    });
  }),
  Webhooks12: lazy(() => {
    return import('@plaid/icons/react/Webhooks12').then((module) => {
      return { default: module.Webhooks12 };
    });
  }),
  Webhooks14: lazy(() => {
    return import('@plaid/icons/react/Webhooks14').then((module) => {
      return { default: module.Webhooks14 };
    });
  }),
  Webhooks16: lazy(() => {
    return import('@plaid/icons/react/Webhooks16').then((module) => {
      return { default: module.Webhooks16 };
    });
  }),
  Webhooks18: lazy(() => {
    return import('@plaid/icons/react/Webhooks18').then((module) => {
      return { default: module.Webhooks18 };
    });
  }),
  Webhooks20: lazy(() => {
    return import('@plaid/icons/react/Webhooks20').then((module) => {
      return { default: module.Webhooks20 };
    });
  }),
};

export type IconName =
  | 'Activity'
  | 'Add'
  | 'AddCircle'
  | 'Ai'
  | 'AiIndustry'
  | 'AlertBell'
  | 'AlertError'
  | 'AlertWarning'
  | 'AppearanceHide'
  | 'AppearanceShow'
  | 'ArrowDown'
  | 'ArrowLeft'
  | 'ArrowRight'
  | 'ArrowRightDown'
  | 'ArrowUp'
  | 'Attachment'
  | 'BankIntelligence'
  | 'BarGraph'
  | 'Behavior'
  | 'Book'
  | 'Bookmark'
  | 'BookOpen'
  | 'Bot'
  | 'Briefcase'
  | 'Build'
  | 'Buildings'
  | 'Bullet'
  | 'Calendar'
  | 'Cancel'
  | 'Car'
  | 'Cart'
  | 'Categories'
  | 'Changelog'
  | 'Check'
  | 'Checkmark'
  | 'ChevronDoubleLeft'
  | 'ChevronDown'
  | 'ChevronLeft'
  | 'ChevronRight'
  | 'ChevronRightDouble'
  | 'ChevronUp'
  | 'ClearedRec'
  | 'Clipboard'
  | 'Clock'
  | 'Close'
  | 'Comment'
  | 'Configure'
  | 'Copy'
  | 'CreditCard'
  | 'Database'
  | 'Demo'
  | 'Dice'
  | 'Docs'
  | 'Document'
  | 'Download'
  | 'Edit'
  | 'Exclamation'
  | 'External'
  | 'Folder'
  | 'FraudRing'
  | 'Fraudster'
  | 'Gear'
  | 'Globe'
  | 'Guide'
  | 'Hand'
  | 'Hashtag'
  | 'Healthcare'
  | 'Heart'
  | 'Help'
  | 'Home'
  | 'IconPlaceholder'
  | 'Id'
  | 'Identity'
  | 'Inbox'
  | 'Income'
  | 'Incomplete'
  | 'Information'
  | 'Institution'
  | 'Insurance'
  | 'Integrations'
  | 'ItemManagement'
  | 'Items'
  | 'Key'
  | 'Learn'
  | 'Libraries'
  | 'Light'
  | 'Lightbulb'
  | 'Lightning'
  | 'LightningFilled'
  | 'LineGraph'
  | 'Link'
  | 'List'
  | 'Lock'
  | 'Login'
  | 'Logout'
  | 'Mail'
  | 'Menu'
  | 'Message'
  | 'Mobile'
  | 'Moon'
  | 'NewWindow'
  | 'Notebook'
  | 'Overflow'
  | 'Override'
  | 'Overview'
  | 'Pause'
  | 'Phone'
  | 'PieChart'
  | 'Pin'
  | 'Platform'
  | 'Play'
  | 'ProductAuth'
  | 'ProductBeacon'
  | 'ProductIdv'
  | 'ProductLayer'
  | 'ProductMonitor'
  | 'ProductProtect'
  | 'Products'
  | 'ProductTransactions'
  | 'Progress'
  | 'Question'
  | 'Refresh'
  | 'RejectedRec'
  | 'Remove'
  | 'Reset'
  | 'Rocket'
  | 'Rotate'
  | 'Safe'
  | 'Sandbox'
  | 'Search'
  | 'SearchAlt'
  | 'Shield'
  | 'ShieldCaution'
  | 'SidebarHide'
  | 'SidebarShow'
  | 'StepComplete'
  | 'StepIncomplete'
  | 'StepInProgress'
  | 'Submit'
  | 'Subtract'
  | 'Switch'
  | 'Tag'
  | 'Terminal'
  | 'ThumbsDown'
  | 'ThumbsUp'
  | 'Transfer'
  | 'Trash'
  | 'Tweet'
  | 'Upload'
  | 'User'
  | 'Users'
  | 'Video'
  | 'Wallet'
  | 'Webhooks';

